<template>
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity="0.58"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8906 1.52969C19.297 1.52969 10.7031 1.52969 2.10939 1.52969C2.10731 1.51811 2.10106 1.50874 2.09064 1.50156C6.39376 1.49844 10.6969 1.49531 15 1.49219C19.3031 1.49531 23.6063 1.49844 27.9094 1.50156C27.8989 1.50874 27.8927 1.51811 27.8906 1.52969Z"
      fill="#6C6E72"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.1531 1.50781C28.1781 1.52031 28.1781 1.52031 28.1531 1.50781V1.50781Z"
      fill="black"
    />
    <path
      opacity="0.998"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.10937 1.52816C10.7031 1.52816 19.2969 1.52816 27.8906 1.52816C27.9032 1.52816 27.9094 1.53441 27.9094 1.54691C27.8497 1.58279 27.7809 1.59529 27.7031 1.58441C19.1531 1.59691 10.6093 1.5844 2.07187 1.54691C2.07828 1.5312 2.09077 1.52495 2.10937 1.52816Z"
      fill="#F2F3F4"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.67813 1.56641C1.71258 1.56902 1.71883 1.58152 1.69688 1.60391C1.68193 1.59534 1.67568 1.58284 1.67813 1.56641Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.2656 1.56641C28.3001 1.56902 28.3063 1.58152 28.2844 1.60391C28.2694 1.59534 28.2632 1.58284 28.2656 1.56641Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.07188 1.54803C10.6094 1.58552 19.1531 1.59802 27.7031 1.58553C27.7174 2.19944 27.6954 2.81193 27.6375 3.42303C27.6019 3.62133 27.5769 3.82133 27.5625 4.02303C27.4571 4.5079 27.3634 4.9954 27.2813 5.48553C27.225 5.67248 27.1688 5.85998 27.1125 6.04803C27.1063 6.11052 27.0999 6.17303 27.0938 6.23553C27.0105 6.49525 26.9229 6.75151 26.8313 7.00428C26.8251 7.04802 26.8187 7.09178 26.8125 7.13553C26.7422 7.29994 26.6704 7.46243 26.5969 7.62303C26.5682 7.78238 26.5277 7.93864 26.475 8.09178C26.4561 8.10747 26.4341 8.11371 26.4094 8.11053C26.2817 8.39736 26.1692 8.6911 26.0719 8.99178C26.0177 9.01137 25.9772 9.04887 25.95 9.10428C25.8924 9.26783 25.8113 9.41783 25.7063 9.55428C25.6378 9.75404 25.5377 9.93529 25.4063 10.098C25.3247 10.3001 25.2122 10.4814 25.0688 10.6418C25.0103 10.7531 24.954 10.8656 24.9 10.9793C24.8177 11.105 24.7269 11.2238 24.6281 11.3355C24.6124 11.3419 24.6062 11.3544 24.6094 11.373C24.5968 11.373 24.5906 11.3793 24.5906 11.3918C24.5738 11.4051 24.5674 11.4238 24.5719 11.448C24.5432 11.4701 24.5151 11.4951 24.4875 11.523C24.4331 11.6103 24.3769 11.6978 24.3188 11.7855C24.2055 11.8614 24.1179 11.9614 24.0563 12.0855C23.9492 12.1988 23.8493 12.3175 23.7563 12.4418C23.5787 12.6004 23.4225 12.7755 23.2875 12.9668C23.2613 12.9902 23.2331 13.0089 23.2031 13.023C23.2155 10.9479 23.2031 8.87918 23.1656 6.81678C23.1641 6.79334 23.1518 6.77772 23.1281 6.7699C22.9719 6.76677 22.8156 6.76366 22.6594 6.76053C22.0847 6.78556 21.5096 6.80119 20.9344 6.8074C20.9171 6.81441 20.9016 6.82379 20.8875 6.83553C20.8781 9.58551 20.8749 12.3355 20.8781 15.0855C20.7984 15.1611 20.7047 15.2204 20.5969 15.2637C20.5862 15.2862 20.5736 15.3081 20.5594 15.3293C20.3499 15.4287 20.1624 15.5569 19.9969 15.7137C19.8499 15.7335 19.731 15.8023 19.6406 15.9199C19.6042 15.9351 19.5668 15.9445 19.5281 15.948C19.5343 15.3323 19.5281 14.7198 19.5094 14.1105C18.7695 14.0857 18.032 14.0857 17.2969 14.1105C17.2595 15.0916 17.247 16.0791 17.2594 17.073C17.1484 17.0879 17.0484 17.1286 16.9594 17.1949C16.7757 17.2249 16.6007 17.2811 16.4344 17.3637C16.056 17.4879 15.6748 17.6036 15.2906 17.7105C15.1777 17.7183 15.0652 17.7308 14.9531 17.748C14.8422 17.7859 14.7297 17.8203 14.6156 17.8512C13.7393 18.0442 12.8518 18.1567 11.9531 18.1887C8.28439 18.198 4.61563 18.2012 0.946875 18.198C0.946875 13.073 0.946875 7.94802 0.946875 2.82303C0.928125 2.82303 0.909375 2.82303 0.890625 2.82303C0.890625 2.81678 0.890625 2.81052 0.890625 2.80428C0.926293 2.75108 0.938794 2.68857 0.928125 2.61678C0.943841 2.61036 0.950093 2.59788 0.946875 2.57928C0.980246 2.55134 0.992747 2.51384 0.984375 2.46678C1.04795 2.33339 1.1167 2.20214 1.19063 2.07303C1.20938 2.07303 1.22813 2.07303 1.24688 2.07303C1.24688 2.05428 1.24688 2.03553 1.24688 2.01678C1.26562 2.01678 1.28438 2.01678 1.30313 2.01678C1.30313 1.99178 1.30313 1.96677 1.30313 1.94178C1.32188 1.94178 1.34063 1.94178 1.35938 1.94178C1.35938 1.92303 1.35938 1.90428 1.35938 1.88553C1.37813 1.88553 1.39688 1.88553 1.41563 1.88553C1.41288 1.83973 1.42851 1.82723 1.4625 1.84803C1.519 1.78721 1.58463 1.74346 1.65938 1.71678C1.65938 1.69803 1.65938 1.67928 1.65938 1.66053C1.69688 1.66053 1.73438 1.66053 1.77188 1.66053C1.77188 1.64178 1.77188 1.62303 1.77188 1.60428C1.82475 1.60901 1.87475 1.59963 1.92188 1.57615C1.91563 1.5699 1.90937 1.56365 1.90313 1.5574C1.95904 1.54806 2.01529 1.54494 2.07188 1.54803Z"
      fill="#E5E8ED"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.3969 1.62109C28.4207 1.63191 28.4207 1.64441 28.3969 1.65859C28.3789 1.64979 28.3789 1.63728 28.3969 1.62109Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.56561 1.64062C1.59061 1.65313 1.59061 1.65313 1.56561 1.64062V1.64062Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.9094 1.54688C28.0159 1.54913 28.116 1.56788 28.2094 1.60313C28.2054 1.6346 28.2178 1.65335 28.2469 1.65938C28.2596 1.69081 28.2847 1.70331 28.3219 1.69688C28.3485 1.71471 28.3798 1.72096 28.4156 1.71563C28.4115 1.73766 28.4177 1.75641 28.4344 1.77188C28.4719 1.80626 28.5156 1.82501 28.5656 1.82812C28.5656 1.84688 28.5656 1.86563 28.5656 1.88438C28.5844 1.88438 28.6031 1.88438 28.6219 1.88438C28.6219 1.90313 28.6219 1.92188 28.6219 1.94063C28.6406 1.94063 28.6594 1.94063 28.6781 1.94063C28.6781 1.95938 28.6781 1.97813 28.6781 1.99688C28.6969 1.99688 28.7156 1.99688 28.7344 1.99688C28.7344 2.02187 28.7344 2.04688 28.7344 2.07188C28.7531 2.07188 28.7719 2.07188 28.7906 2.07188C28.7878 2.0916 28.791 2.11035 28.8 2.12813C28.8324 2.15653 28.8606 2.18779 28.8844 2.22188C28.9303 2.29307 28.9678 2.36807 28.9969 2.44688C28.9884 2.49394 29.001 2.53144 29.0344 2.55938C29.0312 2.57798 29.0374 2.59046 29.0531 2.59688C29.0499 2.65969 29.0531 2.72218 29.0625 2.78438C29.0696 2.7948 29.079 2.80104 29.0906 2.80313C29.0906 2.80937 29.0906 2.81563 29.0906 2.82188C29.0719 2.82188 29.0531 2.82188 29.0344 2.82188C29.0344 8.37812 29.0344 13.9344 29.0344 19.4906C19.6719 19.4906 10.3094 19.4906 0.946869 19.4906C0.946869 19.0719 0.946869 18.6531 0.946869 18.2344C4.72188 18.2406 8.49689 18.2344 12.2719 18.2156C12.6737 18.1874 13.0737 18.1499 13.4719 18.1031C13.4817 18.0902 13.4942 18.0808 13.5094 18.075C13.7452 18.0665 13.9765 18.0384 14.2031 17.9906C14.207 17.9796 14.2133 17.9703 14.2219 17.9625C14.4165 17.9396 14.6103 17.9114 14.8031 17.8781C14.8132 17.8547 14.8257 17.8328 14.8406 17.8125C14.9781 17.7875 15.1156 17.7625 15.2531 17.7375C15.2703 17.7323 15.2828 17.7229 15.2906 17.7094C15.6748 17.6024 16.056 17.4868 16.4344 17.3625C16.6007 17.28 16.7757 17.2237 16.9594 17.1938C17.0484 17.1274 17.1484 17.0868 17.2594 17.0719C17.2538 17.1519 17.26 17.23 17.2781 17.3063C17.7031 17.3156 18.1281 17.3188 18.5531 17.3156C18.8664 17.3216 19.179 17.3153 19.4906 17.2969C19.5094 16.2344 19.5156 15.172 19.5094 14.1094C19.5281 14.7187 19.5343 15.3312 19.5281 15.9469C19.5667 15.9434 19.6042 15.934 19.6406 15.9188C19.731 15.8011 19.8499 15.7324 19.9969 15.7125C20.1624 15.5557 20.3499 15.4276 20.5594 15.3281C20.5736 15.307 20.5862 15.2851 20.5969 15.2625C20.7047 15.2193 20.7984 15.1599 20.8781 15.0844C20.8989 15.0833 20.9177 15.0771 20.9344 15.0656C20.9344 15.8156 20.9344 16.5656 20.9344 17.3156C21.3594 17.3156 21.7843 17.3156 22.2094 17.3156C22.5189 17.3218 22.8251 17.3156 23.1281 17.2969C23.1469 15.9 23.1531 14.5 23.1469 13.0969C23.1531 13.0969 23.1594 13.0969 23.1656 13.0969C23.1956 13.0821 23.2082 13.0571 23.2031 13.0219C23.2331 13.0078 23.2612 12.989 23.2875 12.9656C23.4225 12.7743 23.5787 12.5993 23.7562 12.4406C23.8492 12.3164 23.9492 12.1976 24.0562 12.0844C24.1179 11.9603 24.2055 11.8602 24.3187 11.7844C24.3769 11.6966 24.4331 11.6091 24.4875 11.5219C24.5151 11.494 24.5432 11.4689 24.5719 11.4469C24.5687 13.3969 24.5719 15.3469 24.5812 17.2969C25.308 17.3209 26.0361 17.3303 26.7656 17.325C26.7761 17.3178 26.7823 17.3084 26.7844 17.2969C26.8001 17.2905 26.8063 17.278 26.8031 17.2594C26.8093 17.2594 26.8157 17.2594 26.8219 17.2594C26.8438 15.3 26.8468 13.3375 26.8312 11.3719C26.8219 11.3625 26.8125 11.3531 26.8031 11.3438C26.0781 11.3344 25.3532 11.3312 24.6281 11.3344C24.7269 11.2226 24.8177 11.1039 24.9 10.9781C24.954 10.8645 25.0102 10.752 25.0687 10.6406C25.2122 10.4802 25.3247 10.299 25.4062 10.0969C25.5377 9.93414 25.6378 9.75289 25.7062 9.55313C25.8112 9.41668 25.8924 9.26668 25.95 9.10313C25.9772 9.04772 26.0177 9.01022 26.0719 8.99063C26.1692 8.68995 26.2817 8.39621 26.4094 8.10938C26.4341 8.11256 26.4561 8.10632 26.475 8.09063C26.5277 7.93749 26.5682 7.78123 26.5969 7.62188C26.6704 7.46128 26.7422 7.29879 26.8125 7.13438C26.8187 7.09063 26.8251 7.04687 26.8312 7.00313C26.9229 6.75036 27.0105 6.4941 27.0937 6.23438C27.0999 6.17188 27.1063 6.10937 27.1125 6.04688C27.1687 5.85883 27.225 5.67133 27.2812 5.48438C27.3634 4.99425 27.4571 4.50675 27.5625 4.02188C27.5769 3.82018 27.6019 3.62018 27.6375 3.42188C27.6954 2.81078 27.7174 2.19829 27.7031 1.58438C27.7809 1.59526 27.8497 1.58275 27.9094 1.54688Z"
      fill="#C8CED6"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.50936 1.6763C1.5258 1.67385 1.5383 1.6801 1.54686 1.69505C1.50358 1.7208 1.49108 1.71455 1.50936 1.6763Z"
      fill="black"
    />
    <path
      opacity="0.251"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.2469 1.65789C28.284 1.65146 28.3091 1.66396 28.3219 1.69539C28.2848 1.70183 28.2596 1.68932 28.2469 1.65789Z"
      fill="#43444A"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.4344 1.677C28.4565 1.6729 28.4753 1.67915 28.4906 1.69575C28.4616 1.72009 28.4428 1.71384 28.4344 1.677Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.45311 1.73438C1.47233 1.74181 1.47546 1.75431 1.46249 1.77188C1.45378 1.76073 1.45066 1.74823 1.45311 1.73438Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.5094 1.73438C28.5242 1.73968 28.5367 1.74905 28.5469 1.7625C28.5221 1.7724 28.5097 1.76303 28.5094 1.73438Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.5656 1.75391C28.5906 1.76641 28.5906 1.76641 28.5656 1.75391V1.75391Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.6219 1.78906C28.6367 1.79436 28.6493 1.80374 28.6594 1.81719C28.6346 1.82709 28.6223 1.81771 28.6219 1.78906Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.32187 1.82971C1.32931 1.81049 1.3418 1.80737 1.35937 1.82034C1.34822 1.82904 1.33572 1.83217 1.32187 1.82971Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.6781 1.84766C28.7149 1.85606 28.7212 1.87481 28.6969 1.90391C28.6802 1.88844 28.674 1.86969 28.6781 1.84766Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.26562 1.88509C1.27644 1.86122 1.28894 1.86122 1.30313 1.88509C1.29432 1.90315 1.28182 1.90315 1.26562 1.88509Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.20938 1.93978C1.2202 1.91591 1.2327 1.91591 1.24688 1.93978C1.23807 1.95783 1.22557 1.95783 1.20938 1.93978Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.7344 1.92188C28.7689 1.92448 28.7751 1.93699 28.7531 1.95938C28.7381 1.95081 28.7319 1.9383 28.7344 1.92188Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.15314 1.99768C1.16057 1.97847 1.17307 1.97533 1.19064 1.98831C1.17949 1.99701 1.16699 2.00014 1.15314 1.99768Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.7906 1.97656C28.8251 1.97917 28.8313 1.99168 28.8094 2.01406C28.7944 2.00549 28.7882 1.99299 28.7906 1.97656Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.09686 2.08984C1.13131 2.09245 1.13756 2.10496 1.11561 2.12734C1.10066 2.11878 1.09441 2.10627 1.09686 2.08984Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.8469 2.09107C28.869 2.08696 28.8877 2.0932 28.9031 2.10982C28.8741 2.13415 28.8553 2.12791 28.8469 2.09107Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.04062 2.14844C1.07506 2.15104 1.08131 2.16355 1.05937 2.18594C1.04442 2.17737 1.03816 2.16486 1.04062 2.14844Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9031 2.14575C28.9253 2.14165 28.944 2.14789 28.9594 2.1645C28.9303 2.18884 28.9116 2.1826 28.9031 2.14575Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.984387 2.25781C1.03383 2.28883 1.02758 2.2982 0.965637 2.28594C0.976062 2.27876 0.982312 2.26938 0.984387 2.25781Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9781 2.25833C28.9946 2.25588 29.007 2.26212 29.0156 2.27708C28.9723 2.30283 28.9598 2.29658 28.9781 2.25833Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0344 2.37109C29.0687 2.38309 29.0751 2.40184 29.0531 2.42734C29.0364 2.41187 29.0303 2.39312 29.0344 2.37109Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.909363 2.40853C0.920178 2.38466 0.932678 2.38466 0.946863 2.40853C0.938054 2.42658 0.925553 2.42658 0.909363 2.40853Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.871874 2.50391C0.891093 2.51135 0.894218 2.52384 0.881249 2.54141C0.872543 2.53027 0.869418 2.51776 0.871874 2.50391Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0906 2.50391C29.1251 2.50651 29.1313 2.51902 29.1094 2.54141C29.0944 2.53284 29.0882 2.52033 29.0906 2.50391Z"
      fill="black"
    />
    <path
      opacity="0.173"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.984367 2.46484C0.992739 2.51191 0.980238 2.54941 0.946867 2.57734C0.937968 2.52893 0.950469 2.49143 0.984367 2.46484Z"
      fill="#333134"
    />
    <path
      opacity="0.239"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9969 2.44531C29.0308 2.4719 29.0432 2.5094 29.0344 2.55781C29.001 2.52987 28.9884 2.49237 28.9969 2.44531Z"
      fill="#252628"
    />
    <path
      opacity="0.149"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.928123 2.61641C0.938791 2.6882 0.926291 2.75071 0.890623 2.80391C0.887523 2.73487 0.890649 2.66613 0.899998 2.59766C0.907171 2.60808 0.916546 2.61432 0.928123 2.61641Z"
      fill="#393A3B"
    />
    <path
      opacity="0.314"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0531 2.59766C29.089 2.65736 29.1015 2.72611 29.0906 2.80391C29.079 2.80182 29.0696 2.79558 29.0625 2.78516C29.0531 2.72296 29.05 2.66047 29.0531 2.59766Z"
      fill="#2D2E2E"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.1469 2.76722C29.1544 2.748 29.1668 2.74487 29.1844 2.75784C29.1733 2.76654 29.1608 2.76967 29.1469 2.76722Z"
      fill="black"
    />
    <path
      opacity="0.73"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.890637 2.82031C0.909387 2.82031 0.928137 2.82031 0.946887 2.82031C0.946887 7.94531 0.946887 13.0703 0.946887 18.1953C0.931286 18.6359 0.921911 19.0796 0.918762 19.5266C0.912513 19.0766 0.906262 18.6266 0.900012 18.1766C0.890637 13.0703 0.887512 7.96408 0.890637 2.85781C0.890637 2.84531 0.890637 2.83282 0.890637 2.82031Z"
      fill="#F7F8FB"
    />
    <path
      opacity="0.141"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.853139 2.87891C0.859389 2.87891 0.86564 2.87891 0.871889 2.87891C0.865644 8.43828 0.871893 13.9945 0.890639 19.5477C0.890639 19.5602 0.890639 19.5726 0.890639 19.5852C0.896862 20.3509 0.890613 21.1133 0.871889 21.8727C0.854866 15.5414 0.848617 9.21018 0.853139 2.87891Z"
      fill="#555556"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0906 2.82031C29.0906 2.82656 29.0906 2.83282 29.0906 2.83906C29.0968 2.83906 29.1032 2.83906 29.1094 2.83906C29.1156 8.41537 29.1094 13.9904 29.0906 19.5641C29.0719 19.5641 29.0531 19.5641 29.0344 19.5641C19.6562 19.5453 10.275 19.5391 0.890629 19.5453C0.871882 13.9922 0.865633 8.43594 0.871879 2.87656C0.871879 2.86406 0.878128 2.85781 0.890629 2.85781C0.887503 7.96408 0.890629 13.0703 0.900004 18.1766C0.906253 18.6266 0.912504 19.0766 0.918754 19.5266C0.921902 19.0796 0.931277 18.6359 0.946879 18.1953C4.61563 18.1984 8.28439 18.1953 11.9531 18.1859C12.8518 18.154 13.7393 18.0415 14.6156 17.8484C14.7297 17.8176 14.8422 17.7832 14.9531 17.7453C15.0652 17.728 15.1777 17.7155 15.2906 17.7078C15.2828 17.7213 15.2703 17.7307 15.2531 17.7359C15.1156 17.7609 14.9781 17.7859 14.8406 17.8109C14.8258 17.8313 14.8133 17.8532 14.8031 17.8766C14.6103 17.9099 14.4166 17.938 14.2219 17.9609C14.2133 17.9687 14.207 17.9781 14.2031 17.9891C13.9765 18.0368 13.7453 18.0649 13.5094 18.0734C13.4942 18.0792 13.4817 18.0886 13.4719 18.1016C13.0737 18.1484 12.6737 18.1859 12.2719 18.2141C8.4969 18.2328 4.72189 18.2391 0.946879 18.2328C0.946879 18.6516 0.946879 19.0704 0.946879 19.4891C10.3094 19.4891 19.6719 19.4891 29.0344 19.4891C29.0344 13.9328 29.0344 8.37656 29.0344 2.82031C29.0531 2.82031 29.0719 2.82031 29.0906 2.82031Z"
      fill="#C6CBD2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.00937 17.7836C4.69066 17.7773 6.37192 17.7836 8.05312 17.8023C7.2125 17.8086 6.37186 17.8148 5.53124 17.8211C4.68427 17.8211 3.84365 17.8086 3.00937 17.7836Z"
      fill="#F1F3EE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.10936 17.711C8.10087 17.7289 8.08838 17.7446 8.07186 17.7579C6.39996 17.7735 4.73121 17.7703 3.06561 17.7485C4.72812 17.7516 6.39062 17.7485 8.05311 17.7391C8.06706 17.7196 8.08581 17.7102 8.10936 17.711Z"
      fill="#C2C9EE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.76562 17.4844C2.80008 17.5302 2.83758 17.577 2.87812 17.625C2.94198 17.6526 3.00447 17.6839 3.06562 17.7187C4.72186 17.7313 6.37812 17.7313 8.03437 17.7187C8.0543 17.6965 8.07931 17.6871 8.10937 17.6906C8.10937 17.6969 8.10937 17.7031 8.10937 17.7094C8.08582 17.7086 8.06707 17.718 8.05312 17.7375C6.39063 17.7469 4.72812 17.75 3.06562 17.7469C3.01149 17.7259 2.95524 17.7071 2.89687 17.6906C2.85937 17.6531 2.82187 17.6156 2.78437 17.5781C2.7692 17.5487 2.76294 17.5174 2.76562 17.4844Z"
      fill="#9EA9ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.06562 16.8828C4.72813 16.8828 6.39062 16.8828 8.05312 16.8828C8.10313 16.9078 8.15312 16.9328 8.20312 16.9578C8.36315 17.1303 8.39128 17.324 8.2875 17.5391C8.22776 17.5918 8.16838 17.6418 8.10937 17.6891C8.07932 17.6855 8.0543 17.6949 8.03437 17.7172C6.37813 17.7297 4.72187 17.7297 3.06562 17.7172C3.00448 17.6823 2.94198 17.651 2.87812 17.6234C2.83758 17.5755 2.80008 17.5286 2.76562 17.4828C2.69096 17.3472 2.69096 17.2097 2.76562 17.0703C2.81672 17.0004 2.87923 16.9442 2.95312 16.9016C2.99062 16.8953 3.02812 16.8891 3.06562 16.8828Z"
      fill="#6E7FED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.14064 17.6703C4.75319 17.6641 6.36569 17.6703 7.97814 17.6891C6.35943 17.7109 4.74067 17.7141 3.12189 17.6984C3.13231 17.6913 3.13856 17.6819 3.14064 17.6703Z"
      fill="#5E71ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.08438 16.8265C4.73514 16.8204 6.38514 16.8266 8.03438 16.8453C8.06209 16.8403 8.08708 16.8466 8.10938 16.864C8.14489 16.8911 8.17613 16.9224 8.20312 16.9578C8.15312 16.9328 8.10313 16.9078 8.05313 16.8828C8.01317 16.8675 7.96943 16.8581 7.92188 16.8546C6.32188 16.8421 4.72187 16.8421 3.12188 16.8546C3.09868 16.859 3.07993 16.8684 3.06563 16.8828C3.02813 16.889 2.99063 16.8953 2.95312 16.9015C2.98624 16.8629 3.02998 16.8379 3.08438 16.8265Z"
      fill="#A4AFED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.05311 16.8852C6.39061 16.8852 4.72812 16.8852 3.06561 16.8852C3.07992 16.8708 3.09867 16.8614 3.12186 16.857C4.72186 16.8445 6.32187 16.8445 7.92186 16.857C7.96941 16.8605 8.01316 16.8699 8.05311 16.8852Z"
      fill="#8190ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.03438 16.8453C6.38515 16.8267 4.73515 16.8204 3.08438 16.8266C3.09222 16.813 3.10471 16.8037 3.12188 16.7984C4.74689 16.7859 6.37187 16.7859 7.99688 16.7984C8.0134 16.8117 8.02589 16.8274 8.03438 16.8453Z"
      fill="#CDD3ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.00939 16.1914C5.70314 16.1914 8.39688 16.1914 11.0906 16.1914C11.1473 16.1998 11.1536 16.2154 11.1094 16.2383C8.40939 16.2508 5.70939 16.2508 3.00939 16.2383C2.96277 16.2251 2.96277 16.2094 3.00939 16.1914Z"
      fill="#EDEFEE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.95312 16.1147C2.97733 16.1102 2.99608 16.1165 3.00937 16.1334C3.01146 16.145 3.0177 16.1544 3.02812 16.1615C5.71562 16.1709 8.40311 16.174 11.0906 16.1709C11.0906 16.1772 11.0906 16.1834 11.0906 16.1897C8.39687 16.1897 5.70313 16.1897 3.00937 16.1897C2.99724 16.1589 2.97849 16.1339 2.95312 16.1147Z"
      fill="#D4D9ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.00937 16.1328C5.70313 16.1328 8.39686 16.1328 11.0906 16.1328C11.0906 16.1453 11.0906 16.1578 11.0906 16.1703C8.40311 16.1734 5.71561 16.1703 3.02812 16.1609C3.01769 16.1538 3.01145 16.1444 3.00937 16.1328Z"
      fill="#A9B2ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5094 14.1085C19.5156 15.171 19.5094 16.2335 19.4906 17.296C19.179 17.3144 18.8664 17.3207 18.5531 17.3147C18.1344 17.3022 17.7156 17.2897 17.2969 17.2772C17.7156 17.2772 18.1344 17.2772 18.5531 17.2772C18.8593 17.2772 19.1657 17.2772 19.4719 17.2772C19.4719 16.2272 19.4719 15.1772 19.4719 14.1272C19.1657 14.1272 18.8593 14.1272 18.5531 14.1272C18.1344 14.1272 17.7156 14.1272 17.2969 14.1272C17.2969 14.121 17.2969 14.1147 17.2969 14.1085C18.032 14.0836 18.7695 14.0836 19.5094 14.1085Z"
      fill="#8BC9BC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.93437 15.3086C2.92186 15.3273 2.90938 15.3461 2.89687 15.3648C2.87846 15.3769 2.85971 15.3894 2.84062 15.4023C2.82959 15.4475 2.80771 15.4851 2.77499 15.5148C2.76249 15.6273 2.76249 15.7398 2.77499 15.8523C2.80629 15.8836 2.82191 15.9211 2.82187 15.9648C2.78321 15.929 2.75508 15.8853 2.73749 15.8336C2.71516 15.6818 2.73704 15.5381 2.80312 15.4023C2.84234 15.3629 2.88609 15.3316 2.93437 15.3086Z"
      fill="#94A0ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0906 15.3098C11.1094 15.3098 11.1281 15.3098 11.1469 15.3098C11.1469 15.3285 11.1469 15.3473 11.1469 15.366C11.2219 15.3785 11.2656 15.4223 11.2781 15.4973C11.3029 15.4941 11.3248 15.5003 11.3438 15.516C11.365 15.6212 11.3743 15.7275 11.3719 15.8348C11.3555 15.8735 11.3336 15.911 11.3063 15.9473C11.2358 16.0148 11.1639 16.0773 11.0906 16.1348C8.39687 16.1348 5.70314 16.1348 3.00938 16.1348C2.99609 16.1178 2.97734 16.1116 2.95313 16.116C2.9098 16.0664 2.86605 16.0164 2.82188 15.966C2.82192 15.9223 2.8063 15.8848 2.775 15.8535C2.7625 15.741 2.7625 15.6285 2.775 15.516C2.80772 15.4862 2.8296 15.4487 2.84063 15.4035C2.85972 15.3905 2.87847 15.378 2.89688 15.366C2.94059 15.3661 2.97809 15.3504 3.00938 15.3191C5.70312 15.3098 8.39687 15.3066 11.0906 15.3098Z"
      fill="#6D7EED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.12188 15.2707C5.75939 15.2676 8.39689 15.2707 11.0344 15.2801C11.0576 15.2844 11.0763 15.2938 11.0906 15.3082C8.39687 15.3051 5.70312 15.3082 3.00938 15.3176C2.97809 15.3489 2.94059 15.3645 2.89688 15.3645C2.90939 15.3457 2.92187 15.327 2.93438 15.3082C2.99552 15.2917 3.05802 15.2793 3.12188 15.2707Z"
      fill="#7686ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.12189 15.2711C5.75624 15.2523 8.39375 15.2461 11.0344 15.2523C11.0531 15.2523 11.0719 15.2523 11.0906 15.2523C11.1191 15.2694 11.1504 15.285 11.1844 15.2992C11.2379 15.3714 11.2973 15.437 11.3625 15.4961C11.4181 15.6102 11.4213 15.7227 11.3719 15.8336C11.3743 15.7263 11.365 15.6201 11.3438 15.5148C11.3248 15.4991 11.3029 15.4929 11.2781 15.4961C11.2656 15.4211 11.2219 15.3773 11.1469 15.3648C11.1469 15.3461 11.1469 15.3273 11.1469 15.3086C11.1281 15.3086 11.1094 15.3086 11.0906 15.3086C11.0763 15.2942 11.0576 15.2848 11.0344 15.2805C8.3969 15.2711 5.75939 15.268 3.12189 15.2711Z"
      fill="#8B98ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0344 15.2531C8.39375 15.2468 5.75624 15.2531 3.12189 15.2718C3.05802 15.2804 2.99553 15.2929 2.93439 15.3093C2.95511 15.277 2.98636 15.2583 3.02814 15.2531C5.69928 15.2281 8.36802 15.2281 11.0344 15.2531Z"
      fill="#A9B4ED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0906 15.2516C11.0719 15.2516 11.0531 15.2516 11.0344 15.2516C8.36802 15.2266 5.69928 15.2266 3.02814 15.2516C3.02814 15.2328 3.02814 15.2141 3.02814 15.1953C5.71563 15.1953 8.40314 15.1953 11.0906 15.1953C11.0906 15.2141 11.0906 15.2328 11.0906 15.2516Z"
      fill="#D2D7EE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.5531 14.1289C18.8593 14.1289 19.1657 14.1289 19.4719 14.1289C19.4719 15.1789 19.4719 16.2289 19.4719 17.2789C19.1657 17.2789 18.8593 17.2789 18.5531 17.2789C18.5531 16.2289 18.5531 15.1789 18.5531 14.1289Z"
      fill="#30AA87"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2969 14.1289C17.7156 14.1289 18.1344 14.1289 18.5531 14.1289C18.5531 15.1789 18.5531 16.2289 18.5531 17.2789C18.1344 17.2789 17.7156 17.2789 17.2969 17.2789C17.2969 16.2289 17.2969 15.1789 17.2969 14.1289Z"
      fill="#4EC4A5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M17.2969 14.1094C17.2969 14.1156 17.2969 14.1219 17.2969 14.1281C17.2969 15.1781 17.2969 16.2281 17.2969 17.2781C17.7156 17.2906 18.1344 17.3031 18.5531 17.3156C18.1281 17.3188 17.7031 17.3156 17.2781 17.3062C17.26 17.23 17.2538 17.1519 17.2594 17.0719C17.247 16.0779 17.2594 15.0904 17.2969 14.1094Z"
      fill="#B2D9D3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.28436 13.0234C7.35312 13.0234 7.42186 13.0234 7.49061 13.0234C7.75013 13.0452 8.01263 13.0452 8.27811 13.0234C8.26128 13.0358 8.24253 13.0483 8.22186 13.0609C7.96585 13.0828 7.70959 13.0859 7.45311 13.0703C7.39446 13.0545 7.33821 13.0389 7.28436 13.0234Z"
      fill="#EAE3C0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.57813 12.9648C8.47958 12.9918 8.37959 13.0106 8.27813 13.0211C8.01265 13.0429 7.75015 13.0429 7.49063 13.0211C7.64701 13.0242 7.80325 13.0211 7.95938 13.0117C8.00693 13.0082 8.05067 12.9989 8.09063 12.9836C8.25353 12.9852 8.41602 12.979 8.57813 12.9648Z"
      fill="#F0D968"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.64688 12.8906C6.78893 12.9169 6.93267 12.9325 7.07813 12.9375C7.1053 12.9584 7.13656 12.9709 7.17188 12.975C7.47807 12.9844 7.78431 12.9875 8.09063 12.9844C8.05067 12.9996 8.00693 13.009 7.95938 13.0125C7.80325 13.0219 7.64701 13.025 7.49063 13.0219C7.42187 13.0219 7.35314 13.0219 7.28438 13.0219C7.1104 13.005 6.93541 12.9769 6.75938 12.9375C6.7177 12.9269 6.6802 12.9113 6.64688 12.8906Z"
      fill="#F4D43D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.32814 12.7773C9.31964 12.7953 9.30716 12.8109 9.29064 12.8242C9.03584 12.8903 8.77961 12.9528 8.52189 13.0117C8.44087 13.0211 8.35962 13.0242 8.27814 13.0211C8.37959 13.0106 8.47959 12.9918 8.57814 12.9648C8.82699 12.9076 9.07698 12.8451 9.32814 12.7773Z"
      fill="#EDDF9D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.99063 12.6836C6.14886 12.7363 6.30512 12.7926 6.45938 12.8523C6.39062 12.8523 6.32189 12.8523 6.25313 12.8523C6.25313 12.8336 6.25313 12.8148 6.25313 12.7961C6.20312 12.7961 6.15314 12.7961 6.10313 12.7961C6.10724 12.7741 6.10099 12.7553 6.08438 12.7398C6.04202 12.7345 6.01077 12.7158 5.99063 12.6836Z"
      fill="#EAE4C8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.82187 12.6094C5.89091 12.6133 5.94716 12.6383 5.99062 12.6844C5.92308 12.6808 5.86683 12.6558 5.82187 12.6094Z"
      fill="#ECE0A5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0406 12.4609C9.95678 12.5431 9.85677 12.5931 9.74063 12.6109C9.82975 12.5414 9.92974 12.4914 10.0406 12.4609Z"
      fill="#EDE0A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5656 12.1211C10.5304 12.1571 10.4929 12.1914 10.4531 12.2242C10.4209 12.2535 10.3834 12.2691 10.3406 12.2711C10.4085 12.2105 10.4835 12.1605 10.5656 12.1211Z"
      fill="#EEDD8A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.9594 11.8047C10.8684 11.925 10.7559 12.0188 10.6219 12.0859C10.6203 12.0673 10.6265 12.0516 10.6406 12.0391C10.7555 11.9709 10.8617 11.8928 10.9594 11.8047Z"
      fill="#ECDFA1"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2031 11.5586C11.1531 11.6211 11.0969 11.6773 11.0344 11.7273C11.0719 11.6523 11.1281 11.5961 11.2031 11.5586Z"
      fill="#EEDD8D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.24686 11.3711C4.36729 11.4732 4.47979 11.5857 4.58436 11.7086C4.58436 11.7148 4.58436 11.7211 4.58436 11.7273C4.47407 11.6378 4.36782 11.544 4.26561 11.4461C4.24819 11.4238 4.24195 11.3988 4.24686 11.3711Z"
      fill="#E5AAA2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.6094 11.3711C25.0281 11.3711 25.4469 11.3711 25.8656 11.3711C25.8656 11.3773 25.8656 11.3836 25.8656 11.3898C25.4469 11.3898 25.0281 11.3898 24.6094 11.3898C24.6094 13.3461 24.6094 15.3023 24.6094 17.2586C24.5906 15.3055 24.5844 13.3492 24.5906 11.3898C24.5906 11.3773 24.5968 11.3711 24.6094 11.3711Z"
      fill="#8FC9BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.3531 11.3906C11.3165 11.4585 11.2665 11.5148 11.2031 11.5594C11.2403 11.491 11.2903 11.4348 11.3531 11.3906Z"
      fill="#ECE0A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.8656 11.3706C26.1686 11.3488 26.4748 11.3457 26.7844 11.3613C26.7938 11.3706 26.8031 11.38 26.8125 11.3894C26.8219 13.3456 26.8251 15.3019 26.8219 17.2581C26.8157 17.2581 26.8093 17.2581 26.8031 17.2581C26.8093 15.305 26.8031 13.355 26.7844 11.4081C26.778 11.3924 26.7654 11.3862 26.7469 11.3894C26.4564 11.3707 26.1626 11.3644 25.8656 11.3706Z"
      fill="#8EC4BB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.8656 11.3906C25.4563 11.4093 25.0438 11.4156 24.6281 11.4094C24.6281 13.3594 24.6281 15.3094 24.6281 17.2594C25.3436 17.2781 26.0625 17.2843 26.7844 17.2781C26.7844 15.3219 26.7844 13.3656 26.7844 11.4094C26.8031 13.3562 26.8093 15.3062 26.8031 17.2594C26.8063 17.278 26.8001 17.2905 26.7844 17.2969C26.0529 17.3093 25.3279 17.2968 24.6094 17.2594C24.6094 15.3031 24.6094 13.3469 24.6094 11.3906C25.0281 11.3906 25.4469 11.3906 25.8656 11.3906Z"
      fill="#6BC3AE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.6281 11.3332C25.3532 11.3301 26.0781 11.3332 26.8031 11.3426C26.8125 11.352 26.8219 11.3613 26.8312 11.3707C26.8468 13.3363 26.8438 15.2988 26.8219 17.2582C26.8251 15.3019 26.8219 13.3457 26.8125 11.3895C26.8031 11.3801 26.7937 11.3707 26.7844 11.3613C26.4748 11.3458 26.1686 11.3489 25.8656 11.3707C25.4469 11.3707 25.0281 11.3707 24.6094 11.3707C24.6062 11.3521 24.6124 11.3396 24.6281 11.3332Z"
      fill="#ABC9C8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M26.7469 11.389C26.7654 11.3857 26.778 11.392 26.7844 11.4077C26.7844 13.364 26.7844 15.3202 26.7844 17.2765C26.0625 17.2827 25.3436 17.2764 24.6281 17.2577C25.0406 17.2577 25.4531 17.2577 25.8656 17.2577C25.8812 15.3082 25.8906 13.3582 25.8937 11.4077C26.1767 11.3891 26.4611 11.3829 26.7469 11.389Z"
      fill="#30AA87"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M25.8656 11.3734C26.1626 11.3672 26.4564 11.3735 26.7469 11.3922C26.4611 11.3861 26.1767 11.3923 25.8937 11.4109C25.8906 13.3614 25.8812 15.3114 25.8656 17.2609C25.4531 17.2609 25.0406 17.2609 24.6281 17.2609C24.6281 15.3109 24.6281 13.3609 24.6281 11.4109C25.0438 11.4171 25.4563 11.4108 25.8656 11.3922C25.8656 11.3859 25.8656 11.3796 25.8656 11.3734Z"
      fill="#4DC3A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.8344 11.3906C15.8562 13.3562 15.8594 15.325 15.8437 17.2969C15.1075 17.3219 14.3732 17.3219 13.6406 17.2969C14.3701 17.3031 15.0982 17.2968 15.825 17.2781C15.8344 15.3156 15.8375 13.3531 15.8344 11.3906Z"
      fill="#B2CEDD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6594 11.3906C13.6594 13.3531 13.6594 15.3156 13.6594 17.2781C14.0719 17.2781 14.4844 17.2781 14.8969 17.2781C15.2001 17.2843 15.5001 17.278 15.7969 17.2594C15.8156 15.3063 15.8219 13.35 15.8156 11.3906C15.8219 11.3906 15.8281 11.3906 15.8344 11.3906C15.8375 13.3531 15.8344 15.3156 15.825 17.2781C15.0982 17.2968 14.3701 17.3031 13.6406 17.2969C13.6406 17.2844 13.6406 17.2719 13.6406 17.2594C13.6344 15.3 13.6406 13.3437 13.6594 11.3906Z"
      fill="#76B1CB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8969 11.3906C15.1969 11.3906 15.4969 11.3906 15.7969 11.3906C15.7969 13.3469 15.7969 15.3031 15.7969 17.2594C15.5002 17.2781 15.2002 17.2843 14.8969 17.2781C14.8969 15.3156 14.8969 13.3531 14.8969 11.3906Z"
      fill="#1E80A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.6594 11.3906C14.0719 11.3906 14.4844 11.3906 14.8969 11.3906C14.8969 13.3531 14.8969 15.3156 14.8969 17.2781C14.4844 17.2781 14.0719 17.2781 13.6594 17.2781C13.6594 15.3156 13.6594 13.3531 13.6594 11.3906Z"
      fill="#2B91BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8969 11.3922C15.1936 11.3735 15.4936 11.3672 15.7969 11.3734C15.8094 11.3734 15.8156 11.3796 15.8156 11.3922C15.8219 13.3515 15.8156 15.3078 15.7969 17.2609C15.7969 15.3047 15.7969 13.3484 15.7969 11.3922C15.4969 11.3922 15.1969 11.3922 14.8969 11.3922Z"
      fill="#529CB8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.7969 11.3703C15.4936 11.3641 15.1936 11.3704 14.8969 11.389C14.4844 11.389 14.0719 11.389 13.6594 11.389C13.6406 13.3421 13.6344 15.2984 13.6406 17.2578C13.6188 15.2984 13.6156 13.3359 13.6312 11.3703C14.355 11.3453 15.0768 11.3453 15.7969 11.3703Z"
      fill="#9BC5DA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.86563 11.4453C4.77812 11.5391 4.69064 11.6328 4.60313 11.7266C4.59689 11.7266 4.59062 11.7266 4.58438 11.7266C4.58438 11.7203 4.58438 11.7141 4.58438 11.7078C4.66673 11.6067 4.76048 11.5192 4.86563 11.4453Z"
      fill="#EB9D3D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M24.5906 11.3906C24.5844 13.35 24.5906 15.3063 24.6094 17.2594C25.3279 17.2968 26.0529 17.3093 26.7844 17.2969C26.7823 17.3084 26.7761 17.3178 26.7656 17.325C26.0361 17.3303 25.308 17.3209 24.5812 17.2969C24.5719 15.3469 24.5687 13.3969 24.5719 11.4469C24.5674 11.4227 24.5737 11.4039 24.5906 11.3906Z"
      fill="#B0CCCC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.6156 11.0352C11.587 11.1295 11.5307 11.2045 11.4469 11.2602C11.5036 11.1835 11.5599 11.1085 11.6156 11.0352Z"
      fill="#EDDF9F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.74688 10.5672C5.45939 10.8672 5.16563 11.161 4.86563 11.4485C5.13586 11.1501 5.41711 10.8594 5.70938 10.5766C5.72052 10.5679 5.73302 10.5648 5.74688 10.5672Z"
      fill="#EB9F3C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.8781 10.6211C11.8618 10.6627 11.8556 10.7064 11.8594 10.7523C11.8406 10.7523 11.8219 10.7523 11.8031 10.7523C11.8059 10.7721 11.8028 10.7908 11.7938 10.8086C11.7496 10.854 11.7121 10.904 11.6813 10.9586C11.6721 10.9828 11.6689 11.0078 11.6719 11.0336C11.6531 11.0336 11.6344 11.0336 11.6156 11.0336C11.6435 10.9778 11.6717 10.9215 11.7 10.8648C11.7612 10.783 11.8205 10.7018 11.8781 10.6211Z"
      fill="#ECE0A9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9906 10.3985C11.9703 10.4859 11.9328 10.5609 11.8781 10.6235C11.8982 10.5563 11.9232 10.4907 11.9531 10.4266C11.9594 10.4073 11.9719 10.3979 11.9906 10.3985Z"
      fill="#ECE0A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.21564 10.0985C6.06564 10.261 5.90939 10.4172 5.74689 10.5672C5.87952 10.4064 6.02326 10.2532 6.17814 10.1078C6.18927 10.0991 6.20178 10.096 6.21564 10.0985Z"
      fill="#EB9F3C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.1031 10.1524C12.0938 10.1895 12.0845 10.227 12.075 10.2649C12.0461 10.3109 12.0179 10.3547 11.9906 10.3961C12.0027 10.3194 12.0277 10.2475 12.0656 10.1805C12.0719 10.1612 12.0844 10.1518 12.1031 10.1524Z"
      fill="#ECE0A4"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2531 9.68359C12.2562 9.7216 12.253 9.7591 12.2437 9.79609C12.1993 9.85354 12.1712 9.91604 12.1594 9.98359C12.1612 9.87207 12.1924 9.77206 12.2531 9.68359Z"
      fill="#EFDB7D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.15314 9.16097C6.84689 9.47972 6.53439 9.79222 6.21564 10.0985C6.50461 9.78131 6.80461 9.47194 7.11564 9.17034C7.12677 9.16164 7.13928 9.15851 7.15314 9.16097Z"
      fill="#EC9F3B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3844 9.16016C12.3875 9.24789 12.3844 9.33537 12.375 9.42266C12.3672 9.43123 12.3579 9.43749 12.3469 9.44141C12.3371 9.52034 12.3152 9.59534 12.2813 9.66641C12.275 9.74141 12.2688 9.81641 12.2625 9.89141C12.2547 9.88284 12.2454 9.87658 12.2344 9.87266C12.2102 9.9131 12.1946 9.95684 12.1875 10.0039C12.1742 10.0204 12.1586 10.0329 12.1406 10.0414C12.1362 10.0172 12.1424 9.99845 12.1594 9.98516C12.1712 9.9176 12.1993 9.85511 12.2438 9.79766C12.253 9.76066 12.2562 9.72316 12.2531 9.68516C12.2806 9.54466 12.3118 9.40717 12.3469 9.27266C12.3594 9.23516 12.3719 9.19766 12.3844 9.16016Z"
      fill="#E9E4C7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.21564 9.10156C3.22188 9.10156 3.22814 9.10156 3.23439 9.10156C3.26075 9.23877 3.28574 9.37629 3.30939 9.51406C3.28263 9.48316 3.26701 9.44566 3.26251 9.40156C3.24476 9.30159 3.22914 9.20157 3.21564 9.10156Z"
      fill="#E4A39A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.62189 8.69222C7.47189 8.85472 7.31564 9.01097 7.15314 9.16097C7.28577 9.00013 7.42951 8.847 7.58439 8.70159C7.59552 8.69289 7.60803 8.68976 7.62189 8.69222Z"
      fill="#ECA037"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4219 8.69141C12.4303 8.85005 12.4178 9.00629 12.3844 9.16016C12.3719 9.19766 12.3594 9.23516 12.3469 9.27266C12.3617 9.07511 12.3867 8.88134 12.4219 8.69141Z"
      fill="#EEDD86"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.4031 8.44649C12.4216 8.524 12.4278 8.60526 12.4219 8.69024C12.3867 8.88017 12.3617 9.07394 12.3469 9.27149C12.3118 9.406 12.2806 9.54349 12.2531 9.68399C12.1924 9.77245 12.1612 9.87246 12.1594 9.98399C12.1424 9.99728 12.1362 10.016 12.1406 10.0402C12.1174 10.0724 12.1049 10.1099 12.1031 10.1527C12.0844 10.1522 12.0719 10.1615 12.0656 10.1809C12.0277 10.2478 12.0027 10.3197 11.9906 10.3965C11.9719 10.3959 11.9594 10.4053 11.9531 10.4246C11.9232 10.4887 11.8982 10.5544 11.8781 10.6215C11.8205 10.7021 11.7612 10.7834 11.7 10.8652C11.6717 10.9219 11.6435 10.9781 11.6156 11.034C11.5599 11.1074 11.5036 11.1824 11.4469 11.259C11.4085 11.2974 11.3772 11.3412 11.3531 11.3902C11.2903 11.4344 11.2403 11.4906 11.2031 11.559C11.1281 11.5965 11.0719 11.6527 11.0344 11.7277C10.9929 11.7351 10.9679 11.7601 10.9594 11.8027C10.8617 11.8908 10.7555 11.9689 10.6406 12.0371C10.6265 12.0497 10.6203 12.0653 10.6219 12.084C10.5932 12.0826 10.5745 12.0951 10.5656 12.1215C10.4835 12.1609 10.4085 12.2109 10.3406 12.2715C10.2406 12.334 10.1406 12.3965 10.0406 12.459C9.92973 12.4894 9.82974 12.5394 9.74062 12.609C9.60931 12.6799 9.4718 12.7361 9.32812 12.7777C9.07696 12.8455 8.82697 12.908 8.57812 12.9652C8.41601 12.9794 8.25352 12.9856 8.09062 12.984C7.7843 12.9871 7.47806 12.984 7.17187 12.9746C7.13654 12.9706 7.10529 12.9581 7.07812 12.9371C6.93266 12.9321 6.78892 12.9165 6.64687 12.8902C6.58355 12.8816 6.52104 12.8691 6.45937 12.8527C6.30511 12.793 6.14885 12.7367 5.99062 12.684C5.94716 12.6379 5.89091 12.6129 5.82187 12.609C5.82243 12.5903 5.81306 12.5778 5.79374 12.5715C5.74687 12.5559 5.69999 12.5402 5.65312 12.5246C5.57236 12.4546 5.48174 12.4014 5.38124 12.3652C5.30677 12.2953 5.22239 12.2421 5.12812 12.2059C4.99378 12.0935 4.85628 11.9841 4.71562 11.8777C4.66904 11.8316 4.63154 11.7816 4.60312 11.7277C4.69063 11.634 4.77811 11.5402 4.86562 11.4465C5.16562 11.159 5.45938 10.8652 5.74687 10.5652C5.90938 10.4152 6.06562 10.259 6.21562 10.0965C6.53437 9.79024 6.84688 9.47774 7.15312 9.15899C7.31563 9.00899 7.47187 8.85274 7.62187 8.69024C7.70557 8.61593 7.78683 8.5378 7.86562 8.45586C9.37811 8.44649 10.8906 8.44336 12.4031 8.44649Z"
      fill="#F8CE02"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.17813 7.92188C3.17813 8.21563 3.17813 8.50937 3.17813 8.80313C3.16373 8.78882 3.15435 8.77007 3.15 8.74688C3.1375 8.47813 3.1375 8.20937 3.15 7.94063C3.15719 7.9302 3.16656 7.92396 3.17813 7.92188Z"
      fill="#E5C1BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.86564 8.41016C7.87188 8.41016 7.87814 8.41016 7.88439 8.41016C7.89063 8.41016 7.89689 8.41016 7.90314 8.41016C9.40314 8.42266 10.9031 8.43515 12.4031 8.44766C10.8906 8.44452 9.37812 8.44766 7.86564 8.45703C7.78685 8.53897 7.70559 8.6171 7.62189 8.69141C7.68316 8.60503 7.75192 8.52376 7.82814 8.44766C7.84689 8.44141 7.85939 8.42891 7.86564 8.41016Z"
      fill="#D6B745"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.3844 7.86719C12.3992 7.88798 12.4086 7.91298 12.4125 7.94219C12.4219 8.09206 12.425 8.24206 12.4219 8.39219C10.925 8.41092 9.42503 8.41718 7.92188 8.41094C7.92188 8.40469 7.92188 8.39843 7.92188 8.39219C9.39688 8.39219 10.8719 8.39219 12.3469 8.39219C12.3835 8.28768 12.396 8.17518 12.3844 8.05469C12.3844 7.99219 12.3844 7.92968 12.3844 7.86719Z"
      fill="#898FD3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.92188 3.87109C7.93749 5.3617 7.94687 6.85546 7.95 8.35234C9.4143 8.33363 10.8799 8.32737 12.3469 8.33359C12.3469 8.35234 12.3469 8.37109 12.3469 8.38984C10.8719 8.38984 9.39688 8.38984 7.92188 8.38984C7.92188 6.8836 7.92188 5.37734 7.92188 3.87109Z"
      fill="#6375F0"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.23437 7.75391C3.21444 8.20378 3.21444 8.65378 3.23437 9.10391C3.22812 9.10391 3.22186 9.10391 3.21562 9.10391C3.21562 9.06641 3.21562 9.02891 3.21562 8.99141C3.20572 8.7791 3.19947 8.56661 3.19687 8.35391C3.19267 8.14987 3.20516 7.94986 3.23437 7.75391Z"
      fill="#E26E5B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.92188 3.8332C7.99714 3.83008 8.07214 3.83321 8.14688 3.84257C8.09342 3.86674 8.03717 3.87611 7.97813 3.8707C7.97813 5.3457 7.97813 6.82069 7.97813 8.2957C9.42812 8.2957 10.8781 8.2957 12.3281 8.2957C12.322 8.20731 12.3283 8.11982 12.3469 8.0332C12.3597 8.04 12.3722 8.04625 12.3844 8.05195C12.396 8.17243 12.3835 8.28493 12.3469 8.38945C12.3469 8.3707 12.3469 8.35195 12.3469 8.3332C10.8799 8.32697 9.4143 8.33323 7.95 8.35195C7.94687 6.85506 7.93749 5.3613 7.92188 3.8707C7.92188 3.85819 7.92188 3.8457 7.92188 3.8332Z"
      fill="#576CED"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.2531 7.1719C12.2718 7.17134 12.2843 7.18071 12.2906 7.20002C12.2938 7.29497 12.3219 7.37935 12.375 7.45315C12.3747 7.57652 12.3935 7.69527 12.4312 7.8094C12.4467 8.00642 12.4436 8.20019 12.4219 8.39065C12.425 8.24052 12.4219 8.09052 12.4125 7.94065C12.4086 7.91144 12.3992 7.88644 12.3844 7.86565C12.3509 7.63231 12.3072 7.40104 12.2531 7.1719Z"
      fill="#C5CBEC"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.29064 7.39844C3.29763 7.52365 3.27888 7.64239 3.23439 7.75469C3.20518 7.95064 3.19269 8.15065 3.19689 8.35469C3.1995 8.56739 3.20574 8.77988 3.21564 8.99219C3.18731 8.93511 3.1748 8.8726 3.17814 8.80469C3.17814 8.51093 3.17814 8.21719 3.17814 7.92344C3.19706 7.74239 3.23456 7.56738 3.29064 7.39844Z"
      fill="#E4978C"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.34688 7.17188C3.35048 7.25441 3.33173 7.32941 3.29063 7.39687C3.28703 7.31434 3.30578 7.23934 3.34688 7.17188Z"
      fill="#E38C7F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1656 6.81641C23.2031 8.87881 23.2155 10.9476 23.2031 13.0227C23.2082 13.0579 23.1956 13.0829 23.1656 13.0977C23.1656 11.0039 23.1656 8.91016 23.1656 6.81641Z"
      fill="#FBF3F5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1469 13.0969C23.1531 14.5 23.1469 15.9 23.1281 17.2969C23.1313 13.8094 23.1281 10.3219 23.1188 6.83438C22.8201 6.80944 22.5233 6.80944 22.2281 6.83438C21.8048 6.82824 21.3829 6.83449 20.9625 6.85313C20.9469 10.3281 20.9499 13.8032 20.9719 17.2781C21.3868 17.2904 21.7993 17.3029 22.2094 17.3156C21.7843 17.3156 21.3594 17.3156 20.9344 17.3156C20.9344 16.5656 20.9344 15.8156 20.9344 15.0656C20.9282 12.3174 20.9344 9.57056 20.9531 6.825C21.525 6.81731 22.0969 6.80794 22.6688 6.79688C22.8264 6.79701 22.9826 6.80325 23.1375 6.81563C23.1469 8.90936 23.1501 11.0031 23.1469 13.0969Z"
      fill="#92BED2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1281 17.2976C22.8247 17.3038 22.5247 17.2975 22.2281 17.2789C22.5251 17.285 22.8189 17.2788 23.1094 17.2601C23.1094 13.7976 23.1094 10.3351 23.1094 6.87261C22.8189 6.85393 22.5251 6.84767 22.2281 6.85386C22.2281 6.84762 22.2281 6.84135 22.2281 6.83511C22.5232 6.81017 22.8201 6.81017 23.1187 6.83511C23.1281 10.3226 23.1313 13.8101 23.1281 17.2976Z"
      fill="#4995B2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1094 6.87109C23.1094 10.3336 23.1094 13.7961 23.1094 17.2586C22.8225 17.2467 22.5351 17.2342 22.2469 17.2211C22.5154 17.2024 22.7841 17.1961 23.0531 17.2023C23.0531 13.7711 23.0531 10.3398 23.0531 6.90859C22.7843 6.91172 22.5156 6.90859 22.2469 6.89922C22.5349 6.89521 22.8225 6.88583 23.1094 6.87109Z"
      fill="#0F789D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2281 6.85387C22.5251 6.84768 22.8189 6.85394 23.1094 6.87262C22.8225 6.88736 22.5349 6.89673 22.2469 6.90074C22.5156 6.91012 22.7842 6.91325 23.0531 6.91012C23.0531 10.3414 23.0531 13.7726 23.0531 17.2039C22.7841 17.1976 22.5154 17.2039 22.2469 17.2226C22.5351 17.2357 22.8225 17.2482 23.1094 17.2601C22.8189 17.2788 22.5251 17.2851 22.2281 17.2789C22.2281 17.2726 22.2281 17.2664 22.2281 17.2601C22.2311 13.8129 22.2281 10.3629 22.2187 6.91012C22.1852 6.88726 22.1882 6.86851 22.2281 6.85387Z"
      fill="#1F81A3"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2281 6.85384C22.1882 6.86848 22.1852 6.88723 22.2187 6.91009C22.2281 10.3629 22.2311 13.8129 22.2281 17.2601C21.8094 17.2601 21.3906 17.2601 20.9719 17.2601C20.9687 13.7976 20.9719 10.3351 20.9812 6.87259C21.3954 6.85395 21.8111 6.84771 22.2281 6.85384Z"
      fill="#2B91BE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.2281 6.83431C22.2281 6.84055 22.2281 6.84682 22.2281 6.85306C21.8111 6.84693 21.3955 6.85317 20.9813 6.87181C20.9719 10.3343 20.9687 13.7968 20.9719 17.2593C21.3906 17.2593 21.8095 17.2593 22.2281 17.2593C22.2281 17.2656 22.2281 17.2718 22.2281 17.2781C22.5248 17.2967 22.8248 17.303 23.1281 17.2968C22.8251 17.3155 22.519 17.3217 22.2094 17.3156C21.7993 17.3029 21.3868 17.2904 20.9719 17.2781C20.95 13.8031 20.947 10.3281 20.9625 6.85306C21.3829 6.83442 21.8048 6.82818 22.2281 6.83431Z"
      fill="#6DB0CD"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M23.1656 6.81406C23.1656 8.90782 23.1656 11.0016 23.1656 13.0953C23.1594 13.0953 23.1531 13.0953 23.1469 13.0953C23.1501 11.0016 23.1469 8.9078 23.1375 6.81406C22.9826 6.80169 22.8264 6.79544 22.6687 6.79531C22.0969 6.80637 21.525 6.81575 20.9531 6.82344C20.9344 9.569 20.9282 12.3159 20.9344 15.0641C20.9177 15.0755 20.8989 15.0817 20.8781 15.0828C20.8749 12.3328 20.8781 9.5828 20.8875 6.83281C20.9016 6.82107 20.9171 6.8117 20.9344 6.80469C21.5096 6.79848 22.0847 6.78284 22.6594 6.75781C22.8156 6.76094 22.9719 6.76406 23.1281 6.76719C23.1517 6.77501 23.1641 6.79062 23.1656 6.81406Z"
      fill="#D5E1E9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.85311 5.99219C3.83245 6.08734 3.78869 6.16861 3.72186 6.23594C3.74832 6.17641 3.7702 6.11389 3.78749 6.04844C3.80697 6.02575 3.82885 6.007 3.85311 5.99219Z"
      fill="#E49A8F"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.96562 5.82031C3.94839 5.89205 3.91089 5.9483 3.85312 5.98906C3.8702 5.91875 3.9077 5.8625 3.96562 5.82031Z"
      fill="#E49F95"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.5219 5.69141C11.6004 5.7323 11.6504 5.79479 11.6719 5.87891C11.6429 5.87289 11.6303 5.85414 11.6344 5.82266C11.6156 5.82266 11.5969 5.82266 11.5781 5.82266C11.5679 5.77507 11.5492 5.73131 11.5219 5.69141Z"
      fill="#A8AFEA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.07814 5.65234C4.07285 5.73209 4.03535 5.78834 3.96564 5.82109C3.98274 5.75073 4.02024 5.69448 4.07814 5.65234Z"
      fill="#E5A39A"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.94063 4.77344C4.80419 4.90668 4.66356 5.03793 4.51876 5.16719C4.37239 5.31642 4.23801 5.47266 4.11563 5.63594C4.15431 5.57748 4.18868 5.51496 4.21876 5.44844C4.31939 5.35409 4.41314 5.25409 4.50001 5.14844C4.61504 5.05218 4.72442 4.94905 4.82813 4.83906C4.86076 4.8073 4.89826 4.78542 4.94063 4.77344Z"
      fill="#E49083"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4906 4.66016C10.5636 4.69047 10.6261 4.73422 10.6781 4.79141C10.6278 4.75462 10.5715 4.72649 10.5094 4.70703C10.4953 4.69445 10.489 4.67883 10.4906 4.66016Z"
      fill="#9DA5EA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.35311 4.49219C5.22814 4.60465 5.09063 4.6984 4.94061 4.77344C4.94061 4.75469 4.94061 4.73594 4.94061 4.71719C5.00877 4.67436 5.08377 4.63999 5.16561 4.61406C5.18131 4.59511 5.18755 4.57323 5.18436 4.54844C5.24313 4.53454 5.29938 4.51579 5.35311 4.49219Z"
      fill="#E6A79E"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3219 4.54688C10.3974 4.55342 10.4537 4.59092 10.4906 4.65937C10.4291 4.62892 10.3728 4.59142 10.3219 4.54688Z"
      fill="#A0A9EB"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.98438 4.33984C10.093 4.37388 10.1867 4.43013 10.2656 4.50859C10.1719 4.47109 10.0781 4.43359 9.98438 4.39609C9.98438 4.37734 9.98438 4.35859 9.98438 4.33984Z"
      fill="#8C95E9"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.93439 4.19253C5.77792 4.26134 5.62167 4.33634 5.46564 4.41753C5.50181 4.38663 5.53931 4.35537 5.57814 4.32378C5.66163 4.28705 5.74287 4.24643 5.82189 4.2019C5.85888 4.19262 5.89638 4.18949 5.93439 4.19253Z"
      fill="#E5A49B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M6.23439 4.05859C6.16996 4.08754 6.10747 4.12191 6.04689 4.16172C6.00905 4.17119 5.97155 4.18056 5.93439 4.18984C6.01914 4.11632 6.11915 4.07258 6.23439 4.05859Z"
      fill="#E39286"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.90313 3.79804C8.44879 3.78437 8.96754 3.89063 9.45938 4.11679C9.33859 4.08696 9.21983 4.05259 9.10313 4.01367C9.04721 4.00433 8.99096 4.0012 8.93438 4.00429C8.93438 3.98554 8.93438 3.96679 8.93438 3.94804C8.8257 3.96166 8.72571 3.93977 8.63438 3.88242C8.47581 3.88052 8.31956 3.86177 8.16563 3.82617C8.08088 3.81091 7.99961 3.81404 7.92188 3.83554C7.92188 3.84805 7.92188 3.86054 7.92188 3.87304C7.92188 5.37929 7.92188 6.88555 7.92188 8.39179C7.90314 6.86371 7.89688 5.33245 7.90313 3.79804Z"
      fill="#847FD5"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.88436 3.79639C7.88436 3.80263 7.88436 3.80889 7.88436 3.81514C7.66553 3.81201 7.44678 3.81514 7.22811 3.82451C7.17543 3.83918 7.12542 3.85481 7.07811 3.87139C6.92753 3.89241 6.77753 3.9174 6.62811 3.94639C6.63019 3.93482 6.63644 3.92544 6.64686 3.91826C6.83494 3.87623 7.02244 3.83248 7.20936 3.78701C7.43763 3.77153 7.66263 3.77464 7.88436 3.79639Z"
      fill="#E4978B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.88437 3.79688C7.89061 3.79688 7.89688 3.79688 7.90312 3.79688C7.89688 5.33128 7.90314 6.86254 7.92187 8.39062C7.92187 8.39687 7.92187 8.40313 7.92187 8.40938C7.91563 8.40938 7.90936 8.40938 7.90312 8.40938C7.89688 8.40938 7.89061 8.40938 7.88437 8.40938C7.88437 6.87812 7.88437 5.34688 7.88437 3.81563C7.88437 3.80938 7.88437 3.80312 7.88437 3.79688Z"
      fill="#AE6082"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.88437 3.81367C7.88437 5.34493 7.88437 6.87617 7.88437 8.40742C7.87813 8.40742 7.87187 8.40742 7.86562 8.40742C7.86562 6.88243 7.86562 5.35742 7.86562 3.83242C7.70938 3.83242 7.55312 3.83242 7.39687 3.83242C7.2918 3.85282 7.18554 3.86531 7.07812 3.86992C7.12543 3.85335 7.17544 3.83771 7.22812 3.82305C7.44679 3.81367 7.66554 3.81054 7.88437 3.81367Z"
      fill="#D95A4D"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39688 3.83594C7.55312 3.83594 7.70939 3.83594 7.86563 3.83594C7.86563 5.36093 7.86563 6.88594 7.86563 8.41094C7.85939 8.42969 7.84688 8.44219 7.82813 8.44844C7.82813 6.92344 7.82813 5.39843 7.82813 3.87344C7.67676 3.88529 7.53301 3.87278 7.39688 3.83594Z"
      fill="#EF502B"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.92188 3.83528C7.99961 3.81377 8.08088 3.81064 8.16563 3.82591C8.31956 3.86151 8.47581 3.88026 8.63438 3.88216C8.72571 3.93951 8.8257 3.96139 8.93438 3.94778C8.93438 3.96653 8.93438 3.98528 8.93438 4.00403C8.99096 4.00094 9.04721 4.00407 9.10313 4.01341C9.21983 4.05233 9.33859 4.0867 9.45938 4.11653C9.52629 4.12945 9.59192 4.1482 9.65625 4.17278C9.76755 4.23051 9.87694 4.28676 9.98438 4.34153C9.98438 4.36028 9.98438 4.37903 9.98438 4.39778C10.0781 4.43528 10.1719 4.47278 10.2656 4.51028C10.2943 4.50891 10.313 4.52142 10.3219 4.54778C10.3728 4.59233 10.4291 4.62983 10.4906 4.66028C10.489 4.67896 10.4953 4.69457 10.5094 4.70716C10.5715 4.72662 10.6278 4.75474 10.6781 4.79153C10.9652 5.03796 11.2308 5.30671 11.475 5.59778C11.4955 5.62737 11.5112 5.65862 11.5219 5.69153C11.5492 5.73143 11.5679 5.77519 11.5781 5.82278C11.5969 5.82278 11.6156 5.82278 11.6344 5.82278C11.6303 5.85426 11.6429 5.87301 11.6719 5.87903C11.7319 5.97957 11.7975 6.07956 11.8688 6.17903C11.9148 6.33353 11.9804 6.47727 12.0656 6.61028C12.105 6.76936 12.1644 6.91936 12.2438 7.06028C12.253 7.09727 12.2562 7.13477 12.2531 7.17278C12.3072 7.40192 12.3509 7.63319 12.3844 7.86653C12.3844 7.92902 12.3844 7.99154 12.3844 8.05403C12.3722 8.04833 12.3597 8.04209 12.3469 8.03528C12.3283 8.12191 12.322 8.20939 12.3281 8.29778C10.8781 8.29778 9.42812 8.29778 7.97813 8.29778C7.97813 6.82277 7.97813 5.34779 7.97813 3.87278C8.03717 3.8782 8.09342 3.86882 8.14688 3.84466C8.07214 3.8353 7.99714 3.83217 7.92188 3.83528Z"
      fill="#5F6FE7"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39687 3.83594C7.53299 3.87278 7.67675 3.88529 7.82812 3.87344C7.82812 5.39843 7.82812 6.92344 7.82812 8.44844C7.7519 8.52454 7.68314 8.60581 7.62187 8.69219C7.60801 8.68973 7.59551 8.69286 7.58437 8.70156C7.42949 8.84697 7.28576 9.0001 7.15312 9.16094C7.13926 9.15848 7.12676 9.16161 7.11562 9.17031C6.80459 9.47191 6.50459 9.78128 6.21562 10.0984C6.20176 10.096 6.18926 10.0991 6.17812 10.1078C6.02324 10.2532 5.87951 10.4064 5.74687 10.5672C5.73301 10.5647 5.72051 10.5679 5.70937 10.5766C5.41709 10.8594 5.13584 11.15 4.86562 11.4484C4.76047 11.5223 4.66672 11.6098 4.58437 11.7109C4.4798 11.5881 4.3673 11.4756 4.24687 11.3734C4.15259 11.2666 4.06511 11.1541 3.98437 11.0359C3.91304 10.881 3.82243 10.7372 3.71249 10.6047C3.53486 10.2559 3.40048 9.89341 3.30937 9.51719C3.28573 9.37941 3.26073 9.2419 3.23437 9.10469C3.21444 8.65456 3.21444 8.20456 3.23437 7.75469C3.27886 7.64239 3.29761 7.52365 3.29062 7.39844C3.33172 7.33098 3.35047 7.25598 3.34687 7.17344C3.37475 7.04288 3.41225 6.91476 3.45937 6.78906C3.54159 6.6175 3.61659 6.44251 3.68437 6.26406C3.69067 6.24475 3.70318 6.23538 3.72187 6.23594C3.78869 6.16861 3.83246 6.08734 3.85312 5.99219C3.91089 5.95143 3.94839 5.89517 3.96562 5.82344C4.03533 5.79068 4.07283 5.73443 4.07812 5.65469C4.09063 5.64844 4.10311 5.64218 4.11562 5.63594C4.238 5.47266 4.37238 5.31642 4.51874 5.16719C4.66355 5.03793 4.80418 4.90668 4.94062 4.77344C5.09064 4.6984 5.22815 4.60465 5.35312 4.49219C5.39137 4.46669 5.42887 4.44169 5.46562 4.41719C5.62166 4.336 5.7779 4.261 5.93437 4.19219C5.97153 4.18291 6.00903 4.17353 6.04687 4.16406C6.10745 4.12426 6.16994 4.08989 6.23437 4.06094C6.35405 3.98988 6.4853 3.95238 6.62812 3.94844C6.77754 3.91945 6.92754 3.89446 7.07812 3.87344C7.18554 3.86882 7.29179 3.85634 7.39687 3.83594Z"
      fill="#E1533B"
    />
    <path
      opacity="0.933"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0906 2.83984C29.0751 8.4016 29.0657 13.9641 29.0625 19.5273C29.0593 16.7461 29.0563 13.9648 29.0531 11.1836C29.0531 8.39607 29.0657 5.61481 29.0906 2.83984Z"
      fill="#EEF3FC"
    />
    <path
      opacity="0.969"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.890625 19.5453C10.275 19.5391 19.6562 19.5453 29.0344 19.564C19.6687 19.5578 10.3062 19.564 0.946875 19.5828C0.928125 19.5828 0.909375 19.5828 0.890625 19.5828C0.890625 19.5702 0.890625 19.5578 0.890625 19.5453Z"
      fill="#ACB2BB"
    />
    <path
      opacity="0.949"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.946869 19.5836C10.3062 19.5648 19.6687 19.5586 29.0344 19.5648C29.0531 19.5648 29.0719 19.5648 29.0906 19.5648C29.0906 20.3336 29.0906 21.1023 29.0906 21.8711C29.0906 21.8898 29.0906 21.9086 29.0906 21.9273C29.0784 21.9329 29.0659 21.9393 29.0531 21.9461C29.0344 21.1588 29.0282 20.3713 29.0344 19.5836C19.6719 19.5836 10.3094 19.5836 0.946869 19.5836Z"
      fill="#9599A3"
    />
    <path
      opacity="0.137"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0906 21.8703C29.0906 21.1016 29.0906 20.3328 29.0906 19.5641C29.1094 13.9904 29.1156 8.41537 29.1094 2.83906C29.121 2.83698 29.1304 2.83074 29.1375 2.82031C29.1501 9.18281 29.1501 15.5453 29.1375 21.9078C29.1296 21.8842 29.1141 21.8718 29.0906 21.8703Z"
      fill="#343437"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.890637 19.5859C0.909387 19.5859 0.928137 19.5859 0.946887 19.5859C10.3094 19.5859 19.672 19.5859 29.0344 19.5859C29.0282 20.3736 29.0344 21.1611 29.0531 21.9484C29.0659 21.9417 29.0785 21.9353 29.0906 21.9297C29.0906 21.9423 29.0906 21.9546 29.0906 21.9672C29.0479 22.0169 29.0417 22.0731 29.0719 22.1359C29.0428 22.1419 29.0305 22.1607 29.0344 22.1922C29.0076 22.2162 28.995 22.2475 28.9969 22.2859C28.888 22.5364 28.7254 22.7521 28.5094 22.9328C28.476 22.9746 28.4321 22.9964 28.3781 22.9984C28.3781 23.0172 28.3781 23.0359 28.3781 23.0547C28.3468 23.0547 28.3157 23.0547 28.2844 23.0547C28.2844 23.0734 28.2844 23.0922 28.2844 23.1109C28.2469 23.1109 28.2094 23.1109 28.1719 23.1109C28.1719 23.1297 28.1719 23.1484 28.1719 23.1672C28.0716 23.1998 27.9655 23.2186 27.8531 23.2234C26.3438 23.1985 24.8282 23.1859 23.3063 23.1859C21.7843 23.1859 20.2688 23.1985 18.7594 23.2234C16.2594 23.2234 13.7594 23.2234 11.2594 23.2234C9.74381 23.1985 8.22194 23.1859 6.69376 23.1859C5.16558 23.1859 3.64372 23.1985 2.12814 23.2234C2.01586 23.2186 1.90962 23.1998 1.80939 23.1672C1.80939 23.1484 1.80939 23.1297 1.80939 23.1109C1.77189 23.1109 1.73439 23.1109 1.69689 23.1109C1.69689 23.0922 1.69689 23.0734 1.69689 23.0547C1.66564 23.0547 1.63439 23.0547 1.60314 23.0547C1.60314 23.0359 1.60314 23.0172 1.60314 22.9984C1.57814 22.9984 1.55314 22.9984 1.52814 22.9984C1.42392 22.8863 1.31454 22.7738 1.20001 22.6609C1.18053 22.6139 1.15553 22.57 1.12501 22.5297C1.11251 22.5048 1.10001 22.5048 1.08751 22.5297C1.05255 22.4474 1.01817 22.3662 0.984387 22.2859C0.99151 22.2447 0.97901 22.2136 0.946887 22.1922C0.951337 22.168 0.945087 22.1493 0.928137 22.1359C0.93818 22.0759 0.925681 22.0261 0.890637 21.9859C0.893913 21.9462 0.887663 21.9087 0.871887 21.8734C0.890611 21.1141 0.89686 20.3517 0.890637 19.5859Z"
      fill="#838691"
    />
    <path
      opacity="0.141"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.853115 2.87891C0.848593 9.21018 0.854842 15.5414 0.871865 21.8727C0.857467 21.8869 0.848092 21.9057 0.84374 21.9289C0.828129 15.5532 0.831253 9.20317 0.853115 2.87891Z"
      fill="#1E1E21"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8969 20.9346C15.1563 20.9217 15.3344 21.0342 15.4312 21.2721C15.476 21.6117 15.3291 21.7992 14.9906 21.8346C14.851 21.8265 14.7291 21.7767 14.625 21.6846C14.5351 21.5254 14.5164 21.3567 14.5687 21.1783C14.6459 21.0473 14.7553 20.9661 14.8969 20.9346Z"
      fill="#C6CCD4"
    />
    <path
      opacity="0.013"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0906 21.9648C29.097 22.0361 29.0908 22.0923 29.0719 22.1336C29.0417 22.0708 29.0479 22.0145 29.0906 21.9648Z"
      fill="#121214"
    />
    <path
      opacity="0.176"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.890616 21.9844C0.925659 22.0245 0.938158 22.0744 0.928116 22.1344C0.916539 22.1364 0.907164 22.1426 0.899991 22.1531C0.890653 22.0973 0.887529 22.041 0.890616 21.9844Z"
      fill="#1E1F20"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.871887 22.1914C0.896887 22.204 0.896887 22.204 0.871887 22.1914V22.1914Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0344 22.1914C29.0423 22.2342 29.0299 22.2655 28.9969 22.2852C28.995 22.2467 29.0076 22.2154 29.0344 22.1914Z"
      fill="#0A0A0D"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0906 22.1914C29.1156 22.204 29.1156 22.204 29.0906 22.1914V22.1914Z"
      fill="black"
    />
    <path
      opacity="0.102"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.946874 22.1914C0.978997 22.2128 0.991497 22.2439 0.984374 22.2852C0.978562 22.3084 0.969187 22.3084 0.956249 22.2852C0.946996 22.2546 0.943871 22.2233 0.946874 22.1914Z"
      fill="#19191A"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.909363 22.3772C0.920178 22.3534 0.932678 22.3534 0.946863 22.3772C0.938054 22.3952 0.925553 22.3952 0.909363 22.3772Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M29.0344 22.3594C29.0812 22.3596 29.0844 22.3721 29.0437 22.3969C29.0351 22.3858 29.0319 22.3733 29.0344 22.3594Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M0.965637 22.4905C0.979711 22.4704 0.998461 22.4673 1.02189 22.4811C1.00591 22.5136 0.987157 22.5168 0.965637 22.4905Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9781 22.4727C29.025 22.4728 29.0282 22.4854 28.9875 22.5102C28.9789 22.4991 28.9757 22.4865 28.9781 22.4727Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.9219 22.5469C28.9468 22.5594 28.9468 22.5594 28.9219 22.5469V22.5469Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.09686 22.6406C1.13131 22.6433 1.13756 22.6558 1.11561 22.6781C1.10066 22.6695 1.09441 22.6571 1.09686 22.6406Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.8469 22.6406C28.8934 22.6449 28.9028 22.6575 28.875 22.6781C28.8557 22.6718 28.8463 22.6594 28.8469 22.6406Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.15314 22.6953C1.18997 22.7037 1.19622 22.7225 1.17189 22.7516C1.15528 22.7362 1.14903 22.7174 1.15314 22.6953Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.7906 22.6953C28.8501 22.7037 28.8564 22.7225 28.8094 22.7516C28.7927 22.7362 28.7865 22.7174 28.7906 22.6953Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.20938 22.7913C1.2202 22.7675 1.2327 22.7675 1.24688 22.7913C1.23807 22.8093 1.22557 22.8093 1.20938 22.7913Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.7344 22.7913C28.7452 22.7675 28.7576 22.7675 28.7719 22.7913C28.7631 22.8093 28.7505 22.8093 28.7344 22.7913Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.26562 22.846C1.27644 22.8222 1.28894 22.8222 1.30313 22.846C1.29432 22.864 1.28182 22.864 1.26562 22.846Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.6781 22.8454C28.6856 22.826 28.698 22.823 28.7156 22.836C28.7046 22.8446 28.692 22.8478 28.6781 22.8454Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.32187 22.8828C1.35631 22.8854 1.36256 22.898 1.34062 22.9203C1.32567 22.9117 1.31941 22.8993 1.32187 22.8828Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.6219 22.8828C28.6564 22.8854 28.6626 22.898 28.6406 22.9203C28.6256 22.9117 28.6194 22.8993 28.6219 22.8828Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.37811 22.9414C1.41256 22.944 1.41881 22.9566 1.39686 22.9789C1.38191 22.9703 1.37566 22.9579 1.37811 22.9414Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.5656 22.9414C28.6001 22.944 28.6063 22.9566 28.5844 22.9789C28.5694 22.9703 28.5632 22.9579 28.5656 22.9414Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.43439 22.9973C1.45642 22.9932 1.47517 22.9994 1.49064 23.0161C1.46154 23.0405 1.44279 23.0341 1.43439 22.9973Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.4906 23.0141C28.5073 22.9901 28.5261 22.9901 28.5469 23.0141C28.5296 23.034 28.5109 23.034 28.4906 23.0141Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.50939 23.0547C1.55628 23.0549 1.5594 23.0674 1.51876 23.0922C1.51006 23.0811 1.50693 23.0686 1.50939 23.0547Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.4531 23.0547C28.4724 23.0622 28.4754 23.0746 28.4625 23.0922C28.4539 23.0811 28.4507 23.0686 28.4531 23.0547Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.62189 23.1094C1.65633 23.112 1.66258 23.1246 1.64064 23.1469C1.62568 23.1383 1.61943 23.1259 1.62189 23.1094Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.3219 23.1094C28.3564 23.112 28.3626 23.1246 28.3406 23.1469C28.3256 23.1383 28.3194 23.1259 28.3219 23.1094Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.73438 23.1641C1.76882 23.1667 1.77507 23.1792 1.75313 23.2016C1.73817 23.1929 1.73192 23.1806 1.73438 23.1641Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.2094 23.1641C28.2439 23.1667 28.2501 23.1792 28.2281 23.2016C28.2131 23.1929 28.2069 23.1806 28.2094 23.1641Z"
      fill="black"
    />
    <path
      opacity="0.908"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.2594 23.2211C8.22498 23.2149 5.19372 23.2211 2.16561 23.2398C2.15311 23.2337 2.14062 23.2273 2.12811 23.2211C3.64369 23.1962 5.16556 23.1836 6.69374 23.1836C8.22192 23.1836 9.74378 23.1962 11.2594 23.2211Z"
      fill="#9497A3"
    />
    <path
      opacity="0.911"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.8531 23.2211C27.8467 23.2368 27.8342 23.243 27.8156 23.2398C24.8001 23.2211 21.7813 23.2149 18.7594 23.2211C20.2687 23.1962 21.7843 23.1836 23.3062 23.1836C24.8282 23.1836 26.3437 23.1962 27.8531 23.2211Z"
      fill="#9497A4"
    />
    <path
      opacity="0.604"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.16562 23.2398C5.19372 23.2211 8.22498 23.2149 11.2594 23.2211C13.7594 23.2211 16.2594 23.2211 18.7594 23.2211C21.7813 23.2149 24.8001 23.2211 27.8156 23.2398C27.8094 23.2398 27.8031 23.2398 27.7969 23.2398C24.7656 23.2273 21.7406 23.2398 18.7219 23.2773C18.7003 23.3036 18.6816 23.3004 18.6656 23.2679C13.1719 23.2499 7.67814 23.2406 2.18437 23.2398C2.17813 23.2398 2.17186 23.2398 2.16562 23.2398Z"
      fill="#73747F"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.86563 23.2422C1.89062 23.2547 1.89062 23.2547 1.86563 23.2422V23.2422Z"
      fill="black"
    />
    <path
      opacity="0.361"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.7969 23.2391C27.7969 23.2453 27.7969 23.2517 27.7969 23.2578C24.7781 23.2517 21.7594 23.2578 18.7406 23.2766C18.7429 23.288 18.7492 23.2942 18.7594 23.2953C18.7594 23.3015 18.7594 23.3079 18.7594 23.3141C18.7344 23.3141 18.7219 23.3015 18.7219 23.2766C21.7406 23.2391 24.7656 23.2265 27.7969 23.2391Z"
      fill="#474A4F"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28.0969 23.2422C28.1218 23.2547 28.1218 23.2547 28.0969 23.2422V23.2422Z"
      fill="black"
    />
    <path
      opacity="0.153"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.18439 23.2578C5.20314 23.2578 8.22189 23.2578 11.2406 23.2578C11.2451 23.282 11.2388 23.3007 11.2219 23.3141C8.2019 23.2829 5.18939 23.2642 2.18439 23.2578Z"
      fill="#202021"
    />
    <path
      opacity="0.153"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M27.7969 23.2601C24.795 23.2727 21.7826 23.2851 18.7594 23.2976C18.7492 23.2965 18.743 23.2903 18.7406 23.2789C21.7594 23.2601 24.7781 23.2539 27.7969 23.2601Z"
      fill="#202020"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.18439 23.2609C2.18439 23.2547 2.18439 23.2484 2.18439 23.2422C7.67816 23.2429 13.1719 23.2523 18.6656 23.2703C18.6816 23.3027 18.7004 23.3059 18.7219 23.2797C18.7219 23.3046 18.7344 23.3172 18.7594 23.3172C18.7776 23.3417 18.8025 23.3541 18.8344 23.3547C18.8314 23.3927 18.8344 23.4302 18.8438 23.4672C18.8563 23.4921 18.8687 23.4921 18.8813 23.4672C18.8875 23.5047 18.8938 23.5422 18.9 23.5797C18.9126 23.6046 18.9249 23.6046 18.9375 23.5797C18.9437 23.6172 18.9501 23.6547 18.9563 23.6922C19.0309 23.8021 19.0903 23.9207 19.1344 24.0484C19.1773 24.0803 19.2024 24.124 19.2094 24.1797C19.2204 24.1757 19.2298 24.1696 19.2375 24.1609C19.2411 24.2059 19.2505 24.2496 19.2656 24.2922C19.2767 24.2882 19.2861 24.2821 19.2938 24.2734C19.3031 24.3167 19.3061 24.3604 19.3031 24.4047C19.3219 24.4047 19.3406 24.4047 19.3594 24.4047C19.3564 24.4427 19.3594 24.4802 19.3688 24.5172C19.3813 24.5421 19.3937 24.5421 19.4063 24.5172C19.4125 24.5547 19.4188 24.5922 19.425 24.6297C19.4376 24.6546 19.45 24.6546 19.4625 24.6297C19.4687 24.6672 19.4751 24.7047 19.4813 24.7422C19.5497 24.8704 19.6215 24.9955 19.6969 25.1172C19.7091 25.147 19.7185 25.1781 19.725 25.2109C19.7376 25.2359 19.75 25.2359 19.7625 25.2109C19.7661 25.2559 19.7754 25.2996 19.7906 25.3422C19.8017 25.3382 19.8111 25.3321 19.8188 25.3234C19.8281 25.3667 19.8311 25.4104 19.8281 25.4547C19.8469 25.4547 19.8656 25.4547 19.8844 25.4547C19.8844 25.4922 19.8844 25.5297 19.8844 25.5672C19.9031 25.5672 19.9219 25.5672 19.9406 25.5672C19.9376 25.6052 19.9406 25.6427 19.95 25.6797C19.9626 25.7046 19.975 25.7046 19.9875 25.6797C19.9937 25.7172 20.0001 25.7547 20.0063 25.7922C20.0456 25.8379 20.08 25.8878 20.1094 25.9422C20.1246 25.9716 20.1308 26.0029 20.1281 26.0359C20.1469 26.0359 20.1656 26.0359 20.1844 26.0359C20.1844 26.0734 20.1844 26.1109 20.1844 26.1484C20.2031 26.1484 20.2219 26.1484 20.2406 26.1484C20.2376 26.1865 20.2406 26.224 20.25 26.2609C20.2626 26.2859 20.275 26.2859 20.2875 26.2609C20.2969 26.3042 20.2999 26.3479 20.2969 26.3922C20.3156 26.3922 20.3344 26.3922 20.3531 26.3922C20.3531 26.4297 20.3531 26.4672 20.3531 26.5047C20.3719 26.5047 20.3906 26.5047 20.4094 26.5047C20.4094 26.5422 20.4094 26.5797 20.4094 26.6172C20.4094 26.6234 20.4094 26.6297 20.4094 26.6359C16.7969 26.6359 13.1844 26.6359 9.57189 26.6359C9.57189 26.6297 9.57189 26.6234 9.57189 26.6172C9.57189 26.5797 9.57189 26.5422 9.57189 26.5047C9.59064 26.5047 9.60939 26.5047 9.62814 26.5047C9.62814 26.4672 9.62814 26.4297 9.62814 26.3922C9.64689 26.3922 9.66564 26.3922 9.68439 26.3922C9.68133 26.3479 9.68444 26.3042 9.69376 26.2609C9.70627 26.2859 9.71876 26.2859 9.73126 26.2609C9.74054 26.224 9.74368 26.1865 9.74064 26.1484C9.75939 26.1484 9.77814 26.1484 9.79689 26.1484C9.79689 26.1109 9.79689 26.0734 9.79689 26.0359C9.81564 26.0359 9.83439 26.0359 9.85314 26.0359C9.85349 26.0067 9.85974 25.9786 9.87189 25.9516C9.89953 25.8929 9.93389 25.8396 9.97501 25.7922C9.98126 25.7547 9.98752 25.7172 9.99376 25.6797C10.0063 25.7046 10.0188 25.7046 10.0313 25.6797C10.0405 25.6427 10.0437 25.6052 10.0406 25.5672C10.0594 25.5672 10.0781 25.5672 10.0969 25.5672C10.0969 25.5297 10.0969 25.4922 10.0969 25.4547C10.1156 25.4547 10.1344 25.4547 10.1531 25.4547C10.1501 25.4104 10.1532 25.3667 10.1625 25.3234C10.175 25.3484 10.1875 25.3484 10.2 25.3234C10.2063 25.2859 10.2125 25.2484 10.2188 25.2109C10.2313 25.2359 10.2438 25.2359 10.2563 25.2109C10.2655 25.174 10.2687 25.1365 10.2656 25.0984C10.2844 25.0984 10.3031 25.0984 10.3219 25.0984C10.3222 25.0692 10.3285 25.0411 10.3406 25.0141C10.3613 24.9601 10.3957 24.907 10.4438 24.8547C10.45 24.8172 10.4563 24.7797 10.4625 24.7422C10.475 24.7671 10.4875 24.7671 10.5 24.7422C10.5093 24.7052 10.5124 24.6677 10.5094 24.6297C10.5281 24.6297 10.5469 24.6297 10.5656 24.6297C10.5656 24.5922 10.5656 24.5547 10.5656 24.5172C10.5844 24.5172 10.6031 24.5172 10.6219 24.5172C10.6188 24.4729 10.6219 24.4292 10.6313 24.3859C10.639 24.3946 10.6484 24.4007 10.6594 24.4047C10.6747 24.3621 10.684 24.3184 10.6875 24.2734C10.7 24.2984 10.7125 24.2984 10.725 24.2734C10.7343 24.2365 10.7374 24.199 10.7344 24.1609C10.7531 24.1609 10.7719 24.1609 10.7906 24.1609C10.791 24.1317 10.7972 24.1036 10.8094 24.0766C10.8301 24.0226 10.8644 23.9695 10.9125 23.9172C10.9188 23.8797 10.925 23.8422 10.9313 23.8047C10.9438 23.8296 10.9563 23.8296 10.9688 23.8047C10.975 23.7672 10.9813 23.7297 10.9875 23.6922C11 23.7171 11.0125 23.7171 11.025 23.6922C11.0343 23.6552 11.0374 23.6177 11.0344 23.5797C11.0531 23.5797 11.0719 23.5797 11.0906 23.5797C11.0906 23.5422 11.0906 23.5047 11.0906 23.4672C11.1094 23.4672 11.1281 23.4672 11.1469 23.4672C11.1438 23.4229 11.1469 23.3792 11.1563 23.3359C11.164 23.3446 11.1734 23.3507 11.1844 23.3547C11.1972 23.3408 11.2097 23.3282 11.2219 23.3172C11.2388 23.3039 11.2451 23.2851 11.2406 23.2609C8.22189 23.2609 5.20314 23.2609 2.18439 23.2609Z"
      fill="#5C5A67"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0719 23.3711C11.0969 23.3837 11.0969 23.3837 11.0719 23.3711V23.3711Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.8906 23.4469C18.8981 23.4276 18.9105 23.4246 18.9281 23.4375C18.9171 23.4462 18.9045 23.4494 18.8906 23.4469Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.0156 23.4844C11.0406 23.4969 11.0406 23.4969 11.0156 23.4844V23.4844Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.9469 23.5602C18.9544 23.5409 18.9667 23.5379 18.9844 23.5508C18.9733 23.5594 18.9607 23.5626 18.9469 23.5602Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8844 23.7266C10.9094 23.7391 10.9094 23.7391 10.8844 23.7266V23.7266Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.8281 23.8398C10.8531 23.8524 10.8531 23.8524 10.8281 23.8398V23.8398Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1344 23.8984C19.1593 23.911 19.1593 23.911 19.1344 23.8984V23.8984Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7719 23.9531C10.7969 23.9657 10.7969 23.9657 10.7719 23.9531V23.9531Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.1906 24.0078C19.2156 24.0204 19.2156 24.0204 19.1906 24.0078V24.0078Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.7156 24.0664C10.7348 24.0739 10.738 24.0863 10.725 24.1039C10.7163 24.0928 10.7132 24.0803 10.7156 24.0664Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6594 24.1953C10.6844 24.2079 10.6844 24.2079 10.6594 24.1953V24.1953Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.6031 24.3086C10.6281 24.3212 10.6281 24.3212 10.6031 24.3086V24.3086Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.5281 24.4391C10.5356 24.4198 10.5481 24.4168 10.5656 24.4297C10.5545 24.4384 10.542 24.4415 10.5281 24.4391Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4719 24.5547C10.4969 24.5672 10.4969 24.5672 10.4719 24.5547V24.5547Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4156 24.6641C10.4406 24.6766 10.4406 24.6766 10.4156 24.6641V24.6641Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.5469 24.6641C19.5718 24.6766 19.5718 24.6766 19.5469 24.6641V24.6641Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3594 24.7773C10.3844 24.7899 10.3844 24.7899 10.3594 24.7773V24.7773Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.6031 24.7773C19.6281 24.7899 19.6281 24.7899 19.6031 24.7773V24.7773Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.3031 24.8906C10.3281 24.9032 10.3281 24.9032 10.3031 24.8906V24.8906Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.6594 24.8906C19.6843 24.9032 19.6843 24.9032 19.6594 24.8906V24.8906Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2469 25.0039C10.2661 25.0114 10.2692 25.0238 10.2562 25.0414C10.2475 25.0303 10.2444 25.0178 10.2469 25.0039Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7156 25.0234C19.7406 25.036 19.7406 25.036 19.7156 25.0234V25.0234Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.6969 25.0977C19.7218 25.1102 19.7218 25.1102 19.6969 25.0977V25.0977Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1906 25.1328C10.2156 25.1454 10.2156 25.1454 10.1906 25.1328V25.1328Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7719 25.1539C19.7794 25.1346 19.7918 25.1316 19.8094 25.1446C19.7983 25.1532 19.7858 25.1564 19.7719 25.1539Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.1156 25.2672C10.1231 25.2479 10.1356 25.2449 10.1531 25.2579C10.142 25.2665 10.1295 25.2697 10.1156 25.2672Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8281 25.2672C19.8356 25.2479 19.848 25.2449 19.8656 25.2579C19.8546 25.2665 19.842 25.2697 19.8281 25.2672Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0594 25.3766C10.0668 25.3573 10.0793 25.3543 10.0969 25.3672C10.0857 25.3759 10.0732 25.379 10.0594 25.3766Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.8844 25.3766C19.8919 25.3573 19.9042 25.3543 19.9219 25.3672C19.9108 25.3759 19.8982 25.379 19.8844 25.3766Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.0031 25.4727C10.0179 25.4779 10.0304 25.4873 10.0406 25.5008C10.0159 25.5107 10.0034 25.5013 10.0031 25.4727Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.9594 25.4727C19.9787 25.4802 19.9817 25.4925 19.9688 25.5102C19.9601 25.4991 19.9569 25.4865 19.9594 25.4727Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.94687 25.6016C9.97186 25.6141 9.97186 25.6141 9.94687 25.6016V25.6016Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0156 25.6016C20.0406 25.6141 20.0406 25.6141 20.0156 25.6016V25.6016Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.89062 25.7148C9.91562 25.7274 9.91562 25.7274 9.89062 25.7148V25.7148Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.0719 25.7148C20.0968 25.7274 20.0968 25.7274 20.0719 25.7148V25.7148Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.83437 25.8281C9.85359 25.8356 9.85672 25.848 9.84374 25.8656C9.83504 25.8546 9.83191 25.842 9.83437 25.8281Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1281 25.8281C20.1474 25.8356 20.1504 25.848 20.1375 25.8656C20.1289 25.8546 20.1257 25.842 20.1281 25.8281Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.77812 25.9414C9.79734 25.9489 9.80047 25.9613 9.7875 25.9789C9.7788 25.9678 9.77567 25.9553 9.77812 25.9414Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.1844 25.9414C20.2037 25.9489 20.2067 25.9613 20.1938 25.9789C20.1851 25.9678 20.182 25.9553 20.1844 25.9414Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.72189 26.0547C9.74575 26.0656 9.74575 26.0779 9.72189 26.0922C9.70383 26.0834 9.70383 26.0708 9.72189 26.0547Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2406 26.0547C20.2554 26.0599 20.268 26.0693 20.2781 26.0828C20.2534 26.0928 20.241 26.0834 20.2406 26.0547Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.64688 26.2047C9.65432 26.1854 9.66681 26.1824 9.68438 26.1954C9.67324 26.204 9.66074 26.2072 9.64688 26.2047Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.2969 26.2047C20.3044 26.1854 20.3168 26.1824 20.3344 26.1954C20.3233 26.204 20.3108 26.2072 20.2969 26.2047Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.59064 26.3141C9.59808 26.2948 9.61057 26.2918 9.62814 26.3047C9.617 26.3134 9.60449 26.3165 9.59064 26.3141Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.3531 26.3141C20.3606 26.2948 20.373 26.2918 20.3906 26.3047C20.3796 26.3134 20.367 26.3165 20.3531 26.3141Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.53436 26.4102C9.56881 26.4128 9.57505 26.4253 9.55311 26.4477C9.53815 26.439 9.53191 26.4267 9.53436 26.4102Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.4281 26.4102C20.4474 26.4177 20.4504 26.43 20.4375 26.4477C20.4289 26.4366 20.4257 26.424 20.4281 26.4102Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39688 26.6156C7.36244 26.613 7.3562 26.6004 7.37813 26.5781C7.3931 26.5868 7.39934 26.5991 7.39688 26.6156Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5844 26.6175C22.587 26.583 22.5996 26.5768 22.6219 26.5988C22.6133 26.6138 22.6009 26.6199 22.5844 26.6175Z"
      fill="black"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.43437 26.6172C7.44061 26.6172 7.44687 26.6172 7.45312 26.6172C7.45312 26.6359 7.45312 26.6547 7.45312 26.6734C8.14658 26.6676 8.83409 26.6489 9.51562 26.6172C9.53437 26.6172 9.55312 26.6172 9.57187 26.6172C9.57187 26.6234 9.57187 26.6298 9.57187 26.6359C11.3718 26.6609 13.1781 26.6734 14.9906 26.6734C16.8032 26.6734 18.6094 26.6609 20.4094 26.6359C20.4094 26.6298 20.4094 26.6234 20.4094 26.6172C20.4219 26.6172 20.4343 26.6172 20.4469 26.6172C20.4412 26.6294 20.4349 26.6419 20.4281 26.6547C21.1155 26.6734 21.8031 26.6796 22.4906 26.6734C22.4906 27.2673 22.4906 27.8609 22.4906 28.4547C17.4742 28.4423 12.4617 28.4547 7.45312 28.4922C7.4344 27.8704 7.42814 27.2453 7.43437 26.6172Z"
      fill="#848792"
    />
    <path
      opacity="0.396"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.45312 26.6172C8.14063 26.6172 8.82812 26.6172 9.51562 26.6172C8.8341 26.6489 8.14659 26.6676 7.45312 26.6734C7.45312 26.6547 7.45312 26.6359 7.45312 26.6172Z"
      fill="#A7A7AA"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.57187 26.6328C13.1844 26.6328 16.7969 26.6328 20.4094 26.6328C18.6094 26.6578 16.8032 26.6703 14.9906 26.6703C13.1781 26.6703 11.3718 26.6578 9.57187 26.6328Z"
      fill="#737581"
    />
    <path
      opacity="0.279"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39688 26.6172C7.40939 26.6172 7.42187 26.6172 7.43438 26.6172C7.42816 27.2453 7.43442 27.8704 7.45313 28.4922C7.45313 28.4984 7.45313 28.5047 7.45313 28.5109C7.43234 28.5098 7.41359 28.5036 7.39688 28.4922C7.39688 27.8672 7.39688 27.2421 7.39688 26.6172Z"
      fill="#22252B"
    />
    <path
      opacity="0.039"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5469 26.6172C22.5594 26.6172 22.5718 26.6172 22.5844 26.6172C22.5844 27.2421 22.5844 27.8672 22.5844 28.4922C22.5677 28.5036 22.5489 28.5098 22.5281 28.5109C22.5467 27.8811 22.5531 27.2498 22.5469 26.6172Z"
      fill="#202121"
    />
    <path
      opacity="0.588"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20.4469 26.6172C21.1468 26.6172 21.8469 26.6172 22.5469 26.6172C22.5531 27.2498 22.5467 27.8811 22.5281 28.5109C17.5031 28.5109 12.4781 28.5109 7.45312 28.5109C7.45312 28.5047 7.45312 28.4984 7.45312 28.4922C12.4617 28.4547 17.4742 28.4423 22.4906 28.4547C22.4906 27.8609 22.4906 27.2672 22.4906 26.6734C21.8031 26.6796 21.1155 26.6734 20.4281 26.6547C20.4349 26.6419 20.4412 26.6294 20.4469 26.6172Z"
      fill="#B6B7BC"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.39686 28.4922C7.40097 28.5143 7.39472 28.5331 7.37811 28.5484C7.35377 28.5194 7.36002 28.5006 7.39686 28.4922Z"
      fill="black"
    />
    <path
      opacity="0.01"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M22.5844 28.4922C22.6187 28.5042 22.6251 28.5229 22.6031 28.5484C22.5864 28.5331 22.5802 28.5143 22.5844 28.4922Z"
      fill="black"
    />
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'IconMenuAnalytics',
} as DefineComponent
</script>
